/* SkinKlean cart drawer (15 sep 2026, v2)
   Sustituye al cajón de Kaching Cart. Reglas:
   - Shopify manda: los precios salen siempre de /cart.js (o de la respuesta de /cart/update.js, que es el mismo carrito).
   - Todas las escrituras van en cola, una detrás de otra, para que dos cambios no se pisen.
   - Packs de Kaching Bundles: todas las líneas de un mismo producto (y mismo plan) son UNA tarjeta. Las unidades se
     mueven por una escalera de packs que sale de la configuración de Kaching (Buy 1 → 2+1 → 3+3 → 3+3 + Buy 1 → …),
     y cada paso se escribe con el mismo formato de propiedad `__kaching_bundles` que usa Kaching. No se toca su código.
   - Los packs de cada producto se leen de la propia ficha (si estamos en ella) o de /products/<handle>?view=sk-data,
     una plantilla mínima; se guardan en sessionStorage.
   - Regalos: líneas con propiedad `_sk_gift`. Si la clienta quita uno no vuelve (atributo `_sk_removed_gifts`)
     hasta que se vacía el carrito. Los hace gratis un descuento automático de Shopify.
   - Shipping protection: marcada por defecto; si la clienta la desmarca queda `_sk_sp=off`. No se pinta como línea.
   - 25 oct 2026 · Regalos de campaña (`cfg.promos`, metafield de tienda skinklean.cart_promos): una línea `_sk_gift =
     promo:<clave>` por regalo, de compra única, que entra al cargar cualquier página mientras la promo está viva (fechas
     `from`/`to` y, si lleva `codes`, solo con ese código en el carrito). Entra ANTES de elegir pack porque el botón de
     Kaching salta directo al checkout. La hace gratis un descuento nativo de Shopify (automático o el código); si la
     línea no sale a $0 se quita sola, así nunca se cobra un regalo. Sin productos de pago no se pinta.
     La línea lleva además la propiedad visible `Gift` (texto `note` de la promo) para que en el checkout y en el email
     del pedido se lea que es un regalo añadido por nosotros. */
(function () {
  if (customElements.get('cart-drawer')) return;

  const J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  /* Kaching Bundles parchea window.fetch y reescribe los /cart/add del producto de la ficha (fuerza la cantidad del pack
     seleccionado: pedíamos 2 y llegaba 1). El carrito usa el fetch original, guardado en <head> antes de que cargue
     ninguna app (window.__skFetch, en theme.liquid). Si esa petición falla por red, se reintenta una vez con el
     fetch normal para que la clienta nunca vea un error por esto. */
  const isNative = (f) => { try { return typeof f === 'function' && /\[native code\]/.test(Function.prototype.toString.call(f)); } catch (e) { return false; } };
  const rawFetch = (url, opts) => {
    const clean = isNative(window.__skFetch) ? window.__skFetch : null;
    if (!clean) return window.fetch(url, opts);
    return clean(url, opts).catch((err) => {
      if (err && err.name === 'AbortError') throw err;
      // solo se reintentan lecturas: un POST que falló por red puede haber llegado, y repetirlo añadiría dos veces
      if (opts && opts.method && opts.method !== 'GET') throw err;
      return window.fetch(url, opts);
    });
  };
  /* Automático (regalos, protección): fetch original. Shopify no lo ve, así Meta no recibe AddToCart de algo que la
     clienta no ha pedido. */
  const postRaw = (url, body) =>
    rawFetch(url, { method: 'POST', headers: J, body: JSON.stringify(body), credentials: 'same-origin' }).then(async (r) => {
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw Object.assign(new Error(data.description || data.message || 'Cart error'), { data });
      return data;
    });
  /* 19 sep: las escrituras van por XMLHttpRequest. Shopify lo vigila y emite «product_added_to_cart» (el AddToCart que
     recibe Meta); el fetch original de rawFetch se lo saltaba. Kaching no reescribe estas peticiones (probado). */
  const post = (url, body) =>
    new Promise((resolve, reject) => {
      const x = new XMLHttpRequest();
      x.open('POST', url);
      Object.keys(J).forEach((k) => x.setRequestHeader(k, J[k]));
      x.withCredentials = true;
      x.onload = () => {
        let data = {};
        try { data = JSON.parse(x.responseText || '{}'); } catch (e) {}
        if (x.status < 200 || x.status >= 300) reject(Object.assign(new Error(data.description || data.message || 'Cart error'), { data }));
        else resolve(data);
      };
      x.onerror = () => reject(new Error('Network error'));
      x.send(JSON.stringify(body));
    });
  const getCart = () => rawFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' }).then((r) => r.json());
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const rid = () => Math.random().toString(36).slice(2, 7);
  const planOf = (l) => (l.selling_plan_allocation && l.selling_plan_allocation.selling_plan.id) || 0;
  const DEAL_KEY = 'skc-deal-v5-'; // v5 (6 oct): cada barra lleva sus regalos
  /* 6 oct 2026 · Packs que el carrito deja SIEMPRE igual que la barra de la ficha para su cantidad (ver packExacto).
     Se empieza por las Eye Patches (deal 5VNR); el resto de packs no cambia. */
  const PACK_EXACTO = ['5VNR', '9b7u', 'JDMY', 'Pt84']; // Eye Patches · Neck · Décolleté · Face Mask

  const ICONS = {
    shipping: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7.5" cy="17.5" r="1.7" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="17.5" cy="17.5" r="1.7" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="10" width="16" height="10" rx="1" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M3 7h18v3H3zM12 7v13M12 7c-1.2-3.5-5.5-3.8-5.5-1.2S10 7 12 7zm0 0c1.2-3.5 5.5-3.8 5.5-1.2S14 7 12 7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    star: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5l2.5 5.3 5.8.6-4.3 3.9 1.2 5.7L12 16.1 6.8 19l1.2-5.7-4.3-3.9 5.8-.6z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    tag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12.5L12.5 20 4 11.5V4h7.5z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="8" cy="8" r="1.3" fill="currentColor"/></svg>',
    refill: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.3-5.7M20 4v4.5h-4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    hand: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10m0-1.5a1.5 1.5 0 0 1 3 0V11m0-1a1.5 1.5 0 0 1 3 0v4.5c0 3.6-2.5 6.5-6 6.5-2.6 0-4.1-1.3-5.4-3.5L4.8 14a1.5 1.5 0 0 1 2.4-1.8L9 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  };

  class SKCart extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-skc-config]').textContent); } catch (e) { this.cfg = {}; }
      this.cfg.texts = this.cfg.texts || {};
      this.q = Promise.resolve();
      this.deals = {};        // productId -> pack de Kaching (o null si el producto no tiene)
      this.dealLoads = {};    // productId -> promesa en curso
      this.productCache = {}; // handle -> /products/<handle>.js (solo productos sin Kaching)
      this.kctxCache = {};    // productId -> contexto de Kaching (deal, versión, variante del test)
      this.upsellIndex = 0;
      this.body = this.querySelector('[data-skc-body]');
      const adding = this.querySelector('.skc__adding');
      this._addingHTML = adding ? adding.innerHTML : '';
      this.$ = (s) => this.querySelector(s);
      this.readDeals(document);
      this.bind();
      this._cartBusy = this.run(() => this.syncInicial(), { silent: true }).finally(() => { this._cartBusy = null; }); // 27 oct
      const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
      idle(() => (this.cfg.upsellProducts || []).forEach((p) => this.loadDeal(p.productId, p.handle).then(() => { if (this.cart) this.renderUpsell(this.cart); }).catch(() => {})));
    }

    /* ---------- API que usa el formulario de producto de Dawn ---------- */
    getSectionsToRender() { return []; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents() { this.run(() => this.sync(), { open: this.cfg.autoOpen }); }

    /* ---------- abrir / cerrar ---------- */
    open() {
      if (this.classList.contains('is-open')) return;
      this._lastFocus = document.activeElement;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('skc-lock');
      setTimeout(() => this.$('.skc__panel').focus({ preventScroll: true }), 50);
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('skc-lock');
      if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus({ preventScroll: true });
    }

    bind() {
      document.addEventListener('click', (e) => {
        const icon = e.target.closest('#cart-icon-bubble, a[href="/cart"].header__icon');
        if (icon && !e.metaKey && !e.ctrlKey) {
          e.preventDefault();
          this.open();
          this.run(() => this.sync(), { silent: true });
        }
      });
      // Abrir en el mismo clic de «Add to cart», sin esperar a Shopify: la clienta ve que algo pasa.
      document.addEventListener('submit', (e) => {
        if (!this.cfg.autoOpen || !e.target.closest || !e.target.closest('product-form')) return;
        try { this.pendingFromForm(e.target); } catch (err) {}
        this.classList.add('is-adding');
        this.open();
        clearTimeout(this._addingT);
        this._addingT = setTimeout(() => this.classList.remove('is-adding'), 10000);
      }, true);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      document.addEventListener('cart:refresh', () => this.run(() => this.sync(), { silent: true }));
      // 19 sep: al volver atrás desde el checkout el navegador restaura la página con el botón aún «ocupado» (bfcache).
      // Solo cuando la página vuelve de la caché: en una carga normal no se toca (poner pending a 0 con una tarea en
      // marcha lo dejaba en -1 y el carrito se quedaba en gris para siempre).
      window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        this.querySelectorAll('.is-busy').forEach((el) => el.classList.remove('is-busy'));
        this.classList.remove('is-loading', 'is-busy', 'is-adding');
        this.pending = 0;
        this.q = Promise.resolve();
        this.run(() => this.sync(), { silent: true });
      });
      /* 27 oct 2026 · Página /cart (Dawn): la misma regla que el cajón (auditorias/carrito-regalos-perfecto-27oct.md).
         Antes no se oía nada de lo que hacía Dawn: la condición miraba `window.PUB_SUB_EVENTS`, que es un `const` de
         constants.js y no cuelga de window (se ve por su nombre).
         - Papelera (o 0) en una línea de regalo: la fila lleva `data-sk-gift` (main-cart-items.liquid) y se apunta en
           `_sk_removed_gifts`, como la papelera del cajón, para que no vuelva. Dawn sigue haciendo su parte.
         - Tras cada cambio de Dawn: sincronización (la lista no admite toques mientras tanto, 1–3 s) y, si cambió algo,
           se repinta con el método de Dawn. Dawn cambia las líneas por su NÚMERO: sin esto, el «−» siguiente caía en
           otra línea (probado).
         - «Check out» de /cart: si en ese momento hay una sincronización a medias, se espera a que acabe y se envía
           el formulario ya repintado; si no, sale al instante como siempre. */
      /* En cuanto la clienta toca algo de Dawn en /cart, «Check out» y los botones de pago exprés quedan quietos hasta que
         el carrito se ha puesto al día (los suelta la sincronización tras el cambio de Dawn; tope de 8 s por si Dawn falla). */
      const quietoYa = () => {
        this.bloquearCart(true);
        clearTimeout(this._quietoT);
        this._quietoT = setTimeout(() => { if (!this._cartBusy) this.bloquearCart(false); }, 8000);
      };
      /* Se apunta DESPUÉS de que Dawn termine su cambio (en la escucha de abajo), nunca a la vez: dos escrituras
         simultáneas al carrito pueden pisarse (probado: una vez la guía no llegó a quitarse). */
      this._quitadosPend = [];
      const apuntarQuitado = (row) => {
        const k = row && row.dataset.skGift;
        if (k && !this._quitadosPend.includes(k)) this._quitadosPend.push(k);
      };
      const escribirQuitados = async () => {
        const pend = this._quitadosPend.splice(0);
        if (!pend.length) return;
        const c = await getCart();
        const removed = this.attrList(c, '_sk_removed_gifts');
        let cambio = false;
        pend.forEach((k) => { if (!removed.includes(k)) { removed.push(k); cambio = true; } });
        if (cambio) await postRaw('/cart/update.js', { attributes: { _sk_removed_gifts: JSON.stringify(removed) } });
      };
      document.addEventListener('click', (e) => {
        const rb = e.target.closest && e.target.closest('cart-items cart-remove-button');
        if (rb) apuntarQuitado(rb.closest('[data-sk-gift]'));
        if (rb || (e.target.closest && e.target.closest('cart-items quantity-input button'))) quietoYa();
      }, true);
      document.addEventListener('click', (e) => {
        const qb = e.target.closest && e.target.closest('cart-items [data-sk-kgift] quantity-input button');
        const back = !qb && e.target.closest && e.target.closest('cart-items [data-skc-gift-back]');
        if (!qb && !back) return;
        e.preventDefault(); e.stopImmediatePropagation(); // Dawn no ve este clic: lo hace el carrito, igual que en el cajón
        if (back) { this.desdeCart(async () => { await this.packExacto(back.dataset.skcGiftBack); await this.sync(); }); return; }
        const key = qb.closest('[data-sk-key]').dataset.skKey;
        const dir = qb.name === 'plus' ? 1 : -1;
        this.desdeCart(async () => {
          const g = this.groups(await getCart()).find((x) => x.lines.some((l) => l.key === key));
          if (g) await this.giftStep(g.key, dir);
        });
      }, true);
      document.addEventListener('change', (e) => {
        const inp = e.target.closest && e.target.closest('cart-items input[name="updates[]"]');
        if (inp && +inp.value === 0) apuntarQuitado(inp.closest('[data-sk-gift]'));
        if (inp) quietoYa();
      }, true);
      document.addEventListener('submit', (e) => {
        const f = e.target;
        if (!f || f.id !== 'cart' || !this._cartBusy) return; // sin nada a medias: no se toca, cero espera
        e.preventDefault();
        const btn = e.submitter || document.getElementById('checkout');
        this._cartBusy.then(() => (f.requestSubmit ? f.requestSubmit(btn || undefined) : f.submit()));
      }, true);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
            if (!ev || ev.source === 'product-form' || ev.source === 'sk-cart') return;
            const after = ev.cartData && ev.cartData.items ? ev.cartData : null;
            this.bloquearCart(true);
            this._cartBusy = this.run(async () => {
              try {
                await escribirQuitados();
                const fin = await this.sync();
                if (after && this.firmaCart(fin) !== this.firmaCart(after)) await this.repintarCart();
              } finally { this.decorarCart(); this.bloquearCart(false); this._cartBusy = null; }
            }, { silent: true });
          });
        } catch (e) {}
      }

      this.addEventListener('click', (e) => {
        const t = (s) => e.target.closest(s);
        if (t('[data-skc-close]')) { e.preventDefault(); this.close(); return; }
        let b;
        if ((b = t('[data-skc-gift-step]'))) { if (!b.disabled) this.run(() => this.giftStep(b.dataset.group, +b.dataset.skcGiftStep)); return; }
        if ((b = t('[data-skc-gift-back]'))) { this.run(async () => { await this.packExacto(b.dataset.skcGiftBack); return this.sync(); }); return; }
        if ((b = t('[data-skc-step]'))) { if (!b.disabled) this.stepClick(b.dataset.group, +b.dataset.skcStep); return; }
        if ((b = t('[data-skc-units]'))) { if (!b.disabled) this.queueUnits(b.dataset.group, +b.dataset.units); return; }
        if ((b = t('[data-skc-qty]'))) { this.run(() => this.changeQty(b.dataset.key, +b.dataset.qty)); return; }
        if ((b = t('[data-skc-remove]'))) { const ln = b.closest('.skc__line'); if (ln) ln.classList.add('is-removing'); this.run(() => this.removeKeys(b.dataset.keys.split(','))); return; }
        if ((b = t('[data-skc-subscribe]'))) { b.classList.add('is-busy'); const ln = b.closest('.skc__line'); if (ln) ln.classList.add('is-pending'); this.run(() => this.subscribeGroup(b.dataset.group)); return; }
        if ((b = t('[data-skc-gift-remove]'))) { const ln = b.closest('.skc__line'); if (ln) ln.classList.add('is-removing'); this.run(() => this.removeGift(b.dataset.key, b.dataset.tier)); return; }
        if ((b = t('[data-skc-upsell-add]'))) {
          const up = (this.cfg.upsellProducts || []).find((p) => String(p.variantId) === b.dataset.variant);
          if (up) this.pendingCard({ title: up.title, image: up.image, units: 1, price: this.upsellPrice(up).price });
          const card = b.closest('.skc__card'); if (card) card.classList.add('is-added');
          this.run(() => this.addUpsell(up, +b.dataset.variant));
          return;
        }
        if ((b = t('.skc__card img'))) { const l = b.closest('.skc__card').querySelector('a.skc__card-t'); if (l && l.getAttribute('href') !== '#') window.location.href = l.href; return; }
        if ((b = t('[data-skc-upsell-nav]'))) { const vp = this.$('.skc__cards-vp'); const cd = vp && vp.querySelector('.skc__card'); if (vp && cd) vp.scrollBy({ left: +b.dataset.dir * (cd.offsetWidth + 10), behavior: 'smooth' }); return; }
        if (t('[data-skc-checkout]')) { e.preventDefault(); t('[data-skc-checkout]').classList.add('is-busy'); this.q.then(() => this.sync().catch(() => {})).then(() => { window.location.href = '/checkout'; }); } // 6 oct: una última comprobación (regalos, tramos) antes de salir // espera a que el carrito termine de guardar
      });

      const sp = this.$('[data-skc-sp]');
      if (sp) sp.addEventListener('change', () => this.run(() => this.setProtection(sp.checked), { silent: true }));
    }

    /* ---------- pintado optimista: la clienta ve el cambio en el clic; Shopify confirma el precio después ---------- */
    pendingFromForm(form) {
      const fd = new FormData(form);
      const vid = +fd.get('id');
      const qty = +fd.get('quantity') || 1;
      let kb = null;
      try { kb = JSON.parse(fd.get('properties[__kaching_bundles]') || 'null'); } catch (e) {}
      const pid = (form.querySelector('[name="product-id"]') || {}).value;
      let title = '', image = '';
      const pj = pid && document.querySelector('script.kaching-bundles-product[data-product-id="' + pid + '"]');
      if (pj) {
        try {
          const p = JSON.parse(pj.textContent);
          title = p.title || '';
          const v = (p.variants || []).find((x) => x.id === vid);
          image = (v && v.image && (v.image.url || v.image)) || (p.image && (p.image.url || p.image)) || '';
        } catch (e) {}
      }
      let units = qty, badge = '';
      const deal = pid && this.deals[pid];
      if (deal && kb) {
        const bar = deal.bars.find((b) => b.id === (kb.bar || kb.bid));
        if (bar) { units = bar.units; if (bar.get > 0 || bar.units > 1) badge = bar.title; }
      }
      if (!title) { const h = document.querySelector('.product__title h1, h1'); title = h ? h.textContent.trim() : ''; }
      this.pendingCard({ title, image, units, badge });
    }
    pendingCard({ title, image, units, badge }) {
      const el = this.$('.skc__adding');
      if (!el || !title) return;
      el.classList.add('has-product');
      el.innerHTML = '<span class="skc__adding-img">' + (image ? '<img src="' + esc(this.img(image, 200)) + '" alt="" width="84" height="84">' : '') + '</span>' +
        '<span class="skc__adding-txt"><span class="skc__adding-name">' + esc(title) + ' <span class="skc__adding-units">×' + units + '</span></span>' +
        (badge && this.cfg.lineBadge !== false ? '<span class="skc__badge">' + ICONS.tag + esc(badge) + '</span>' : '') +
        '<span class="skc__adding-t">' + esc(this.cfg.texts.adding || '') + '</span><span class="skc__adding-bar"></span></span>';
      this.classList.add('is-adding');
      clearTimeout(this._addingT);
      this._addingT = setTimeout(() => this.classList.remove('is-adding'), 10000);
    }
    /* «+» y «−» cuentan desde lo que la clienta ya ha pedido, no desde lo que aún está pintado: dos toques rápidos
       suben dos pasos. Los toques seguidos se juntan en una sola escritura. */
    stepClick(groupKey, dir) {
      const g = this.cart && this.groups(this.cart).find((x) => x.key === groupKey);
      if (!g) return;
      this.targets = this.targets || {};
      this.inflight = this.inflight || {};
      const base = this.targets[groupKey] != null ? this.targets[groupKey] : this.inflight[groupKey] != null ? this.inflight[groupKey] : g.units;
      // De uno en uno, siempre. El carrito no sabe de packs: el pack lo elige la función de Kaching en el servidor.
      const target = Math.max(0, Math.min(this.maxUnits(), base + dir));
      if (target === base) return;
      this.queueUnits(groupKey, target);
    }
    queueUnits(groupKey, units) {
      this.targets = this.targets || {};
      this.inflight = this.inflight || {};
      this.jobs = this.jobs || {};
      this.targets[groupKey] = units;
      this.pendingUnits(groupKey, units);
      if (this.jobs[groupKey]) return; // ya hay una escritura en cola: leerá el último número
      this.jobs[groupKey] = true;
      this.run(async () => {
        delete this.jobs[groupKey];
        const t = this.targets[groupKey];
        delete this.targets[groupKey];
        if (t == null) return;
        this.inflight[groupKey] = t;
        const g0 = this.cart && this.groups(this.cart).find((x) => x.key === groupKey);
        // 6 oct 2026 · En los packs de PACK_EXACTO se cambia la cantidad, se ponen los regalos y se sincroniza UNA vez
        // al final (antes eran dos sincronizaciones y se veía un momento el estado intermedio).
        const exacto = !!(g0 && t > 0 && (() => { const k = this.kb(g0.main); return k && PACK_EXACTO.includes(k.deal); })());
        try {
          const tras = await this.setUnits(groupKey, t, false, exacto);
          // Si la cantidad se cambió en sitio, change.js ya devolvió el carrito entero: no se vuelve a pedir.
          const tocado = g0 ? await this.packExacto(g0.productId, exacto ? tras : null).catch((e) => { console.error('[sk-cart] pack', e); return false; }) : false;
          if (exacto || tocado) {
            const fin = await this.sync();
            // Red de seguridad (sin coste): con el carrito final ya leído, si los regalos no cuadran con la cantidad
            // (Kaching tocó la línea a la vez), se corrigen ahora. Si cuadran, packExacto no escribe nada.
            if (g0 && fin && (await this.packExacto(g0.productId, fin).catch(() => false))) await this.sync();
          }
        } finally {
          delete this.inflight[groupKey];
          if (this.targets[groupKey] == null) {
            const ln = this.querySelector('.skc__line[data-group="' + CSS.escape(groupKey) + '"]');
            if (ln) ln.classList.remove('is-pending', 'is-removing');
          }
        }
      });
    }
    pendingUnits(groupKey, units) {
      const ln = this.querySelector('.skc__line[data-group="' + CSS.escape(groupKey) + '"]');
      if (!ln) return;
      if (units <= 0) { ln.classList.add('is-removing'); return; }
      ln.classList.remove('is-removing');
      ln.classList.add('is-pending');
      const v = ln.querySelector('.skc__qty-v'); if (v) v.textContent = units;
    }

    /* Upsell: línea plana. La función de Kaching le pone el pack y la variante del test que toquen. */
    /* Precio que cobra Kaching por 1 unidad (su pack de 1), si el producto tiene deal sin test A/B; si no, el de tarifa. */
    upsellPrice(p) {
      const d = this.deals[String(p.productId)];
      const one = d && !d.ab && (d.bars || []).find((b) => b.units === 1 && b.price != null);
      if (!one) return p;
      const price = Math.round(one.price * this.rate());
      return price > 0 && price < p.price ? Object.assign({}, p, { price, compare: Math.max(+p.compare || 0, p.price) }) : p;
    }
    async addUpsell(up, variantId) {
      await post('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      return this.sync();
    }
    maxUnits() { return Math.max(+this.cfg.maxUnits || 30, 1); }

    /* ---------- cola ---------- */
    run(fn, { open = false, silent = false } = {}) {
      this.pending = (this.pending || 0) + 1;
      if (!silent) this.classList.add('is-loading');
      this.classList.add('is-busy');
      if (open) this.open();
      this.q = this.q
        .then(fn)
        .catch((err) => {
          console.error('[sk-cart]', err);
          const shopifyMsg = err && err.data && (err.data.description || err.data.message); // p. ej. «sin stock»: se enseña
          /* 2 oct 2026 · «updates parameter is invalid» NO se le enseña a la clienta: es una carrera con
             Kaching (reinyecta su pack entre que leemos el carrito y escribimos, y la clave de línea caduca).
             No es culpa suya y no puede hacer nada; el sync de abajo lo arregla solo. */
          const tecnico = shopifyMsg && /parameter is invalid/i.test(shopifyMsg);
          this.flash((!tecnico && shopifyMsg) || this.cfg.texts.error);
          return this.sync().catch(() => {});
        })
        .finally(() => {
          this.pending = Math.max(0, (this.pending || 0) - 1);
          if (!this.pending) this.classList.remove('is-loading', 'is-busy', 'is-adding');
        });
      return this.q;
    }
    /* 27 oct 2026 · /cart: bloquear la lista mientras sincroniza y repintarla con el Section Rendering de Dawn. */
    firmaCart(c) { return c && c.items ? c.items.map((i) => i.key + ':' + i.quantity).join(',') : ''; }
    /* Mientras se pone al día: la lista, «Check out» y los botones de pago exprés (Apple Pay, Google Pay, Shop Pay) de
       /cart quedan quietos, para que nunca se pague con un regalo que ya no toca. Suele durar 1–3 s. */
    bloquearCart(on) {
      if (!document.querySelector('cart-items')) return;
      const m = document.getElementById('main-cart-items');
      if (m) { m.style.pointerEvents = on ? 'none' : ''; m.style.opacity = on ? '0.6' : ''; }
      document.querySelectorAll('#checkout, .cart__dynamic-checkout-buttons, .additional-checkout-buttons, shopify-accelerated-checkout-cart').forEach((el) => {
        el.style.pointerEvents = on ? 'none' : ''; el.style.opacity = on ? '0.5' : '';
        if (el.id === 'checkout') { if (on) el.setAttribute('disabled', ''); else el.removeAttribute('disabled'); }
        el.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    }
    /* /cart igual que el cajón: en las filas de regalo de pack, el «+» solo si aún le toca alguno gratis (y va por
       giftStep, como en el cajón); en la fila del pack, «Add my free gifts back» si se quitó alguno que el pack da. */
    decorarCart() {
      if (!document.querySelector('cart-items') || !this.cart) return;
      const packs = this.packsDeCarrito(this.cart);
      document.querySelectorAll('cart-items [data-sk-key]').forEach((row) => {
        const line = this.cart.items.find((i) => i.key === row.dataset.skKey);
        if (!line) return;
        // Liquid no ve las propiedades «__» de Kaching (27 oct, en vivo): la fila de regalo de pack se marca aquí,
        // con lo que dice /cart.js, y su nombre y foto dejan de enlazar a la ficha de la copia.
        const kb = String((line.properties && line.properties.__kaching_bundles) || '');
        if (!row.hasAttribute('data-sk-kgift') && kb.includes('"gift"')) {
          row.setAttribute('data-sk-kgift', '');
          row.querySelectorAll('a[href]').forEach((a) => {
            if (a.closest('quantity-input, cart-remove-button')) return;
            a.removeAttribute('href'); a.style.pointerEvents = 'none'; a.style.cursor = 'default';
          });
        }
        if (row.hasAttribute('data-sk-kgift')) {
          const plus = row.querySelector('quantity-input button[name="plus"]');
          if (plus) plus.style.display = '';   // 27 oct (noche): el «+» siempre; gratis si le toca, si no de pago
          return;
        }
        const pk = packs.find((x) => x.main.key === line.key);
        const hay = row.querySelector('[data-skc-gift-back]');
        if (pk && pk.falta && !hay) {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'link sk-gift-back'; b.dataset.skcGiftBack = String(line.product_id);
          b.textContent = (this.cfg.texts && this.cfg.texts.giftBack) || 'Add my free gifts back';
          const cell = row.querySelector('.cart-item__details') || row;
          cell.appendChild(b);
        } else if (hay && !(pk && pk.falta)) hay.remove();
      });
    }
    async repintarCart() {
      const ci = document.querySelector('cart-items');
      if (!ci || typeof ci.getSectionsToRender !== 'function') return;
      try {
        const secs = ci.getSectionsToRender();
        // sin «Accept: application/json»: con esa cabecera /cart devuelve el carrito (como /cart.js) y no las secciones
        const r = await rawFetch(window.location.pathname + '?sections=' + secs.map((x) => x.section).join(','), { credentials: 'same-origin', cache: 'no-store' });
        const html = await r.json();
        secs.forEach((x) => {
          const host = document.getElementById(x.id);
          if (!host || !html[x.section]) return;
          (host.querySelector(x.selector) || host).innerHTML = ci.getSectionInnerHTML(html[x.section], x.selector);
        });
      } catch (err) { window.location.reload(); }
    }
    async syncInicial() {
      if (!document.querySelector('cart-items')) return this.sync();
      this.bloquearCart(true);
      try {
        const antes = await getCart();
        const fin = await this.sync();
        if (this.firmaCart(fin) !== this.firmaCart(antes)) await this.repintarCart();
        return fin;
      } finally { this.decorarCart(); this.bloquearCart(false); }
    }
    /* Cualquier cambio hecho desde /cart por sk-cart (regalo «+»/«−», recuperar regalos): igual que tras un cambio de Dawn. */
    async desdeCart(fn) {
      this.bloquearCart(true);
      this._cartBusy = this.run(async () => {
        try { await fn(); await this.repintarCart(); } finally { this.decorarCart(); this.bloquearCart(false); this._cartBusy = null; }
      }, { silent: true });
      return this._cartBusy;
    }
    flash(msg) {
      let el = this.$('.skc__error');
      if (!el) { el = document.createElement('p'); el.className = 'skc__error'; this.body.prepend(el); }
      el.textContent = msg;
      clearTimeout(this._flashT);
      this._flashT = setTimeout(() => el.remove(), 5000);
    }

    /* ---------- clasificación de líneas ---------- */
    spIds() { return [this.cfg.sp && this.cfg.sp.productId].concat(this.cfg.legacySpProductIds || []).filter(Boolean); }
    isSp(i) { return this.spIds().includes(i.product_id); }
    /* Regalo = línea que el carrito añadió (propiedad `_sk_gift`). Si alguien compra la guía desde su ficha es un
       producto normal y se cobra. Quién tiene derecho al 100% lo decide la función de descuento en el servidor. */
    isGift(i) { return !!(i.properties && i.properties._sk_gift); }
    giftTier(i) {
      if (this.isPromo(i)) { const p = this.promoList().find((x) => 'promo:' + x.key === i.properties._sk_gift); return p ? this.promoTier(p) : null; }
      return (this.cfg.tiers || []).find((t) => i.properties && t.key === i.properties._sk_gift) || null;
    }
    /* ---------- regalos de campaña (25 oct 2026) ---------- */
    isPromo(i) { return !!(i.properties && typeof i.properties._sk_gift === 'string' && i.properties._sk_gift.indexOf('promo:') === 0); }
    promoList() { return Array.isArray(this.cfg.promos) ? this.cfg.promos.filter((p) => p && p.key && p.variant) : []; }
    promoTier(p) { return { key: 'promo:' + p.key, on: true, type: 'gift', promo: true, label: p.label || '', threshold: 0, gift: { variantId: p.variant, compare: +p.compare || 0 } }; }
    promoOn(p, cart) {
      const now = Date.now();
      if (p.from && now < Date.parse(p.from)) return false;
      if (p.to && now >= Date.parse(p.to)) return false;
      if (!Array.isArray(p.codes) || !p.codes.length) return true;
      const have = ((cart && cart.discount_codes) || []).map((d) => String((d && d.code) || '').toUpperCase());
      return p.codes.some((c) => { const k = String(c).toUpperCase(); return have.some((h) => h === k || h.indexOf(k + '-') === 0); });
    }
    /* Qué regalos de campaña tocan ahora: uno por variante, una unidad. Lo que ya no toca, sobra o se cobra, fuera. Un
       regalo que se cobra (código caducado, ya usado) se apunta en `_sk_removed_gifts` para no volver a meterlo. */
    planPromos(cart, add, updates, removed, block) {
      const promos = this.promoList();
      const lines = cart.items.filter((i) => this.isPromo(i));
      if (!promos.length && !lines.length) return;
      const off = new Set(promos.filter((p) => removed.includes('promo:' + p.key)).map((p) => String(p.variant)));
      const want = {}, note = {};
      promos.forEach((p) => { const v = String(p.variant); if (!(v in want) && !off.has(v) && this.promoOn(p, cart)) { want[v] = p.key; note[v] = p.note || 'Free gift · added for you automatically'; } });
      const seen = {};
      lines.forEach((l) => {
        const v = String(l.variant_id);
        if (!(v in want) || seen[v]) { updates[l.key] = 0; return; }
        if (l.final_line_price > 0) { updates[l.key] = 0; block.push(l.properties._sk_gift); return; }
        seen[v] = true;
        if (l.quantity > 1) updates[l.key] = 1;
      });
      Object.keys(want).forEach((v) => { if (!seen[v] && !(lines.some((l) => String(l.variant_id) === v))) add.push({ id: +v, quantity: 1, properties: { _sk_gift: 'promo:' + want[v], Gift: note[v] } }); });
    }
    paid(cart) { return cart.items.filter((i) => !this.isSp(i) && !this.isGift(i)); }
    kb(i) { try { return i.properties && i.properties.__kaching_bundles ? JSON.parse(i.properties.__kaching_bundles) : null; } catch (e) { return null; } }
    attrList(cart, name) { try { return JSON.parse((cart.attributes && cart.attributes[name]) || '[]'); } catch (e) { return []; } }
    rate() { return (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1; }
    thresholdCents(t) { return Math.round((+t.threshold || 0) * 100 * this.rate()); }
    /* LO PAGADO (27 oct 2026, regla de Victor): todo el dinero que la clienta paga por productos, después de TODOS los
       descuentos (Kaching, códigos de producto y de pedido), con la protección de envío y con cualquier línea de Kaching
       que se esté cobrando; sin contar nuestros regalos (`_sk_gift`). Misma definición que la extensión del checkout
       `sk-gifts-checkout` (plan.js, `pagado`), que es la que decide: esto solo es para que el cajón y /cart enseñen
       lo mismo antes de llegar al checkout. */
    qualifying(cart) {
      const lineas = cart.items.filter((i) => !this.isGift(i)).reduce((s, i) => s + i.final_line_price, 0);
      const pedido = (cart.cart_level_discount_applications || []).reduce((s, d) => s + (+d.total_allocated_amount || 0), 0);
      return Math.max(0, lineas - pedido);
    }

    /* ---------- sincronización: regalos + protección ---------- */
    async sync(known) {
      let cart = known && known.items ? known : await getCart();
      let fromUpdate = cart === known; // la respuesta de update.js puede venir sin el descuento de pedido
      this.show(cart); // se pinta ya; regalos y protección llegan en la siguiente respuesta
      for (let pass = 0; pass < 2; pass++) {
        const plan = this.plan(cart);
        if (!plan.add.length && !Object.keys(plan.updates).length && !plan.attrs) break;
        // Primero lo que va por clave (recién leída), después lo que se añade: añadir puede cambiar las claves.
        if (Object.keys(plan.updates).length || plan.attrs) {
          const body = { updates: plan.updates };
          if (plan.attrs) body.attributes = plan.attrs;
          cart = await postRaw('/cart/update.js', body); // devuelve el carrito entero
          fromUpdate = true;
        }
        if (plan.add.length) {
          // de uno en uno: si un regalo está agotado no bloquea los demás ni enseña error
          for (const it of plan.add) await postRaw('/cart/add.js', { items: [it] }).catch(() => {});
          cart = await getCart();
          fromUpdate = false;
        }
        this.show(cart);
      }
      // 27 oct 2026: ya no se escribe el sello `_sk_paid` (la función de descuento ya no lo usa; decide el checkout).
      // Se apuntan, solo cuando faltan o cambian y en una sola petición: `_sk_packs` (cuántos regalos da cada pack) y `_sk_tiers`
      // (los tramos del personalizador, que la pieza del checkout no puede leer). `_sk_tiers` va aunque el carrito esté vacío:
      // así, quien va de la ficha al checkout con el botón de Kaching ya lo lleva desde la primera página que vio.
      if (fromUpdate) { cart = await getCart(); fromUpdate = false; this.show(cart); }
      const attrs = {};
      const packs = this.packsAttr(cart);
      if (((cart.attributes && cart.attributes._sk_packs) || '') !== packs) attrs._sk_packs = packs;
      const tiers = this.tiersAttr(cart);
      if (((cart.attributes && cart.attributes._sk_tiers) || '') !== tiers) attrs._sk_tiers = tiers;
      if (Object.keys(attrs).length) {
        await postRaw('/cart/update.js', { attributes: attrs });
        fromUpdate = true;
      }
      // /cart/update.js no siempre trae el descuento de pedido de los regalos: con regalos en el carrito se relee
      // /cart.js para que «FREE» y el total coincidan con lo que cobra el checkout.
      if (fromUpdate && cart.items.some((i) => this.isGift(i))) this.show((cart = await getCart()));
      this.preloadDeals(cart);
      // 6 oct 2026 · Lo que entra suelto (upsell, colección, enlaces de Klaviyo) se convierte en su pack. Una vez.
      if (!this._normalizando) {
        this._normalizando = true;
        try {
          for (let vuelta = 0; vuelta < 2; vuelta++) {
            let cambio = await this.normalizarSueltas(cart).catch((e) => { console.error('[sk-cart] sueltas', e); return false; });
            if (!cambio) cambio = await this.quitarSobrantes(cart).catch((e) => { console.error('[sk-cart] sobrantes', e); return false; });
            if (!cambio) break;
            cart = await this.sync();
          }
        } finally { this._normalizando = false; }
      }
      return cart;
    }
    /* 7 oct 2026 · Kaching cambia la clave de una línea justo cuando la borramos y Shopify ignora el borrado sin avisar:
       al juntar un 2+1 con una suelta quedaba la Eye Mask vieja cobrándose $39. En cada sincronización (y antes del
       checkout) se quitan los regalos de pack que SOBRAN o se cobran. Nunca añade: si la clienta quitó un regalo, se
       respeta. Con el carrito ya leído; solo escribe si encuentra algo. */
    async quitarSobrantes(cart) {
      let cambio = false;
      const pids = new Set(cart.items.filter((i) => { const k = this.kb(i); return k && k.main && !k.gift && !k.bxgy && PACK_EXACTO.includes(k.deal); }).map((i) => String(i.product_id)));
      for (const pid of pids) if (await this.packExacto(pid, cambio ? null : cart, true)) cambio = true;
      return cambio;
    }
    /* 6 oct 2026 · Una línea de un producto con pack de PACK_EXACTO que llega SIN las propiedades de Kaching (upsell del
       carrito, colección, enlace de Klaviyo) se queda fuera del pack: sin regalos, sin botón y con dos líneas si ya
       había una. Aquí se junta con la línea del pack si existe (misma variante y mismo plan), o se convierte en pack
       en su sitio con su matrícula; después packExacto pone los regalos. Devuelve true si ha escrito algo. */
    /* 22 oct: lo que escribe esta función y packExacto va por postRaw (automático, sin AddToCart a Meta ni a Klaviyo). */
    async normalizarSueltas(cart) {
      let tocado = false;
      const sueltas = cart.items.filter((i) => !this.isSp(i) && !this.isGift(i) && !(i.properties && i.properties.__kaching_bundles) && !(i.final_line_price === 0 && i.original_line_price > 0));
      for (const l of sueltas) {
        const pid = String(l.product_id);
        const deal = pid in this.deals ? this.deals[pid] : await this.loadDeal(pid, l.handle).catch(() => null);
        if (!deal || deal.ab || !PACK_EXACTO.includes(deal.nanoId)) continue;
        const c = await getCart();
        const suelta = c.items.find((i) => i.key === l.key) || c.items.find((i) => String(i.product_id) === pid && i.variant_id === l.variant_id && !(i.properties && i.properties.__kaching_bundles));
        if (!suelta) continue;
        const plan = planOf(suelta);
        const main = c.items.find((i) => { const k = this.kb(i); return String(i.product_id) === pid && i.variant_id === suelta.variant_id && planOf(i) === plan && k && k.main && !k.gift && !k.bxgy; });
        if (main) {
          // Se juntan: la línea del pack suma las unidades de la suelta y la suelta se quita.
          await postRaw('/cart/change.js', { id: main.key, quantity: main.quantity + suelta.quantity, properties: Object.assign({}, main.properties || {}), selling_plan: plan || null });
          const c2 = await getCart();
          const s2 = c2.items.find((i) => String(i.product_id) === pid && i.variant_id === suelta.variant_id && planOf(i) === plan && !(i.properties && i.properties.__kaching_bundles));
          if (s2) await postRaw('/cart/update.js', { updates: { [s2.key]: 0 } });
        } else {
          const bar = deal.bars.filter((b) => b.type === 'qb' && b.units <= suelta.quantity).sort((a, b) => b.units - a.units)[0] || deal.bars.find((b) => b.type === 'qb');
          const kb = { deal: deal.nanoId, pp: +pid, main: true, v: deal.versionId, id: rid(), bid: bar ? bar.id : undefined };
          if (plan) kb.sellingPlan = { id: plan, priceAdjustment: await this.planAdj({ handle: suelta.handle }, plan) };
          const props = Object.assign({}, suelta.properties || {}, { __kaching_bundles: JSON.stringify(kb) });
          await postRaw('/cart/change.js', { id: suelta.key, quantity: suelta.quantity, properties: props, selling_plan: plan || null });
        }
        await this.packExacto(pid).catch(() => false);
        tocado = true;
      }
      return tocado;
    }
    show(cart) {
      if (!cart || !cart.items) return;
      this.cart = cart;
      this.render(cart);
      this.classList.remove('is-adding');
      const adding = this.$('.skc__adding');
      if (adding && adding.classList.contains('has-product')) { adding.classList.remove('has-product'); adding.innerHTML = this._addingHTML; }
    }

    plan(cart) {
      const add = [];
      const updates = {};
      let attrs = null;
      const paid = this.paid(cart);
      const removed = this.attrList(cart, '_sk_removed_gifts');
      const block = [];
      this.planPromos(cart, add, updates, removed, block);
      const keepRemoved = removed.filter((k) => String(k).indexOf('promo:') === 0).concat(block);
      if (block.length) attrs = { _sk_removed_gifts: JSON.stringify(removed.concat(block)) };

      // Sin productos de pago: con «keep» (regla de Victor) los regalos se quedan y se cobran a su precio; solo se
      // vacía todo si no queda ningún regalo o el ajuste es «remove».
      const keptGifts = this.cfg.giftBelow !== 'remove' && cart.items.some((i) => this.isGift(i) && !this.isPromo(i));
      if (!paid.length && !keptGifts) {
        cart.items.forEach((i) => { if ((this.isGift(i) && !this.isPromo(i)) || this.isSp(i)) updates[i.key] = 0; });
        // los regalos de campaña se quedan (aún no ha elegido pack); su lista de «no volver a meter» también
        const keepTxt = keepRemoved.length ? JSON.stringify(keepRemoved) : '';
        if (((cart.attributes && cart.attributes._sk_removed_gifts) || '') !== keepTxt || (cart.attributes && cart.attributes._sk_sp)) attrs = { _sk_removed_gifts: keepTxt, _sk_sp: '' };
        return { add, updates, attrs };
      }

      const total = this.qualifying(cart);
      (this.cfg.tiers || []).forEach((t) => {
        if (!t.on || t.type !== 'gift' || !t.gift || !t.gift.variantId) return;
        // El importe viaja en la línea (`_sk_gift_min`, USD) y la app de regalos lo lee de ahí: el tramo y el producto se
        // cambian solo en el Customizer. Si cambiaron, la línea vieja se quita y entra la nueva.
        const min = String(+t.threshold || 0);
        const mine = cart.items.filter((i) => this.isGift(i) && this.giftTier(i) === t);
        const lines = mine.filter((i) => String(i.variant_id) === String(t.gift.variantId) && i.properties._sk_gift_min === min);
        mine.forEach((i) => { if (!lines.includes(i)) updates[i.key] = 0; });
        const unlocked = total >= this.thresholdCents(t);
        if (unlocked && !lines.length && !removed.includes(t.key)) add.push({ id: t.gift.variantId, quantity: 1, properties: { _sk_gift: t.key, _sk_gift_min: min } });
        if (!unlocked && this.cfg.giftBelow === 'remove') lines.forEach((l) => (updates[l.key] = 0));
        if (unlocked && lines.length) lines.forEach((l, n) => { if (n > 0 || l.quantity > 1) updates[l.key] = n === 0 ? 1 : 0; });
      });
      cart.items.forEach((i) => {
        if (!this.isGift(i) || this.isPromo(i)) return;
        const t = this.giftTier(i);
        if (!t || !t.on || t.type !== 'gift') updates[i.key] = 0;
      });

      const sp = this.cfg.sp;
      const spLines = cart.items.filter((i) => this.isSp(i));
      const spOff = cart.attributes && cart.attributes._sk_sp === 'off';
      if (sp) {
        const want = spOff ? false : sp.default || (cart.attributes && cart.attributes._sk_sp === 'on');
        if (want && !spLines.length) {
          // sin propiedades: si ya hay que llamar a add.js va ahí; si no, /cart/update.js lo añade por id de variante
          updates[sp.variantId] = 1;
        }
        if (!want) spLines.forEach((l) => (updates[l.key] = 0));
        spLines.forEach((l, n) => { if (want && (n > 0 || l.quantity > 1)) updates[l.key] = n === 0 ? 1 : 0; });
      } else {
        spLines.forEach((l) => (updates[l.key] = 0));
      }
      return { add, updates, attrs };
    }

    async setProtection(on) {
      if (!this.cfg.sp) return;
      const cart = this.cart || (await getCart());
      const lines = cart.items.filter((i) => this.isSp(i));
      const updates = {};
      if (on && !lines.length && this.paid(cart).length) updates[this.cfg.sp.variantId] = 1;
      if (!on) lines.forEach((l) => (updates[l.key] = 0));
      this.show(await postRaw('/cart/update.js', { updates, attributes: { _sk_sp: on ? 'on' : 'off' } }));
      return this.sync();
    }

    async removeGift(key, tier) {
      const cart = this.cart || (await getCart());
      const removed = this.attrList(cart, '_sk_removed_gifts');
      if (tier && !removed.includes(tier)) removed.push(tier);
      return this.sync(await postRaw('/cart/update.js', { updates: { [key]: 0 }, attributes: { _sk_removed_gifts: JSON.stringify(removed) } }));
    }

    async changeQty(key, qty) {
      await post('/cart/change.js', { id: key, quantity: Math.max(0, qty) });
      return this.sync();
    }

    async removeKeys(keys) {
      const updates = {};
      keys.forEach((k) => (updates[k] = 0));
      return this.sync(await post('/cart/update.js', { updates }));
    }

    /* ---------- packs de Kaching: datos ---------- */
    readDeals(root) {
      const found = {};
      root.querySelectorAll('script.kaching-bundles-product[data-product-id]').forEach((s) => {
        try { const p = JSON.parse(s.textContent); (found[s.dataset.productId] = found[s.dataset.productId] || {}).product = p; } catch (e) {}
      });
      root.querySelectorAll('script.kaching-bundles-deal-block-settings[data-product-id]').forEach((s) => {
        try {
          const d = JSON.parse(s.textContent);
          const f = (found[s.dataset.productId] = found[s.dataset.productId] || {});
          if (!d.dealBars || !d.dealBars.length) return;
          if (!f.deal) f.deal = d;
          (f.all = f.all || []).push(d); // con test A/B hay un bloque por variante
        } catch (e) {}
      });
      Object.keys(found).forEach((pid) => {
        if (!found[pid].deal) return;
        const slim = this.slimDeal(found[pid].deal, found[pid].product);
        if (!slim) return;
        const all = found[pid].all || [found[pid].deal];
        // Las ofertas que se enseñan como etiqueta: las de TODAS las variantes (la clienta ve la suya).
        slim.titles = [];
        all.forEach((d) => d.dealBars.forEach((b) => {
          const oferta = b.dealBarType === 'bxgy' || (b.quantity || 1) > 1;
          if (oferta && b.title && slim.titles.indexOf(b.title) < 0) slim.titles.push(b.title);
        }));
        slim.ab = all.length > 1 || (all[0].abTestVariantsCount || 1) > 1;
        // Los BOGO de cada variante. Sólo hacen falta para suscribir un BOGO: la función de Kaching reparte sola las
        // gratis en compra única, pero con plan de suscripción no — ahí hay que escribir el pack como su widget.
        slim.variants = all.map((d) => ({
          abid: d.abTestVariantId || null,
          bxgy: d.dealBars
            .filter((b) => b.dealBarType === 'bxgy' && b.buyQuantity > 0 && b.getQuantity > 0)
            .map((b) => ({ id: b.id, buy: b.buyQuantity, get: b.getQuantity, units: b.buyQuantity + b.getQuantity }))
            .sort((a, b) => b.units - a.units),
        }));
        this.deals[pid] = slim;
        try { sessionStorage.setItem(DEAL_KEY + pid, JSON.stringify(slim)); } catch (e) {}
      });
      return found;
    }

    slimDeal(d, product) {
      // Lo que cuesta cada pack, para poder elegir la combinación MÁS BARATA de cada cantidad.
      // Kaching guarda el precio cerrado del pack en `discountValue` cuando el tipo es «specific» (44, 88, 132…).
      const unit = ((product && product.variants) || []).map((v) => +v.price).filter((p) => p > 0)[0] || 0;
      const precio = (b, pagan) => {
        const v = +b.discountValue || 0;
        switch (String(b.discountType || '')) {
          case 'specific': return Math.round(v * 100);
          case 'percentage': return Math.round(unit * pagan * (1 - v / 100));
          case 'amount':
          case 'fixed': return Math.max(0, unit * pagan - Math.round(v * 100));
          default: return null; // sin descuento propio (los BXGY): se rellena abajo con el precio del pack de 1
        }
      };
      const regalos = (b) => (b.freeGifts || [])
        .filter((x) => x.giftType === 'product' && x.productGID && x.id)
        .map((x) => ({ gid: x.id, pid: +String(x.productGID).split('/').pop(), qty: x.quantity || 1, soloSub: !!x.applyOnlyForSubscriptions }));
      const bars = (d.dealBars || [])
        .filter((b) => b.dealBarType === 'bxgy' || b.dealBarType === 'quantity-break')
        .map((b) => {
          const bx = b.dealBarType === 'bxgy';
          const planId = b.sellingPlanEnabled !== false && b.sellingPlanGid ? +String(b.sellingPlanGid).split('/').pop() : null;
          if (bx) {
            const buy = b.buyQuantity || 0;
            const get = b.getQuantity || 0;
            return { id: b.id, title: b.title, type: 'bxgy', buy, get, units: buy + get, price: precio(b, buy), planId };
          }
          // «Quantity break» (una sola línea, como Quasi): las unidades gratis salen del nombre («Buy 2 + Get 1 FREE»).
          const qty = b.quantity || 1;
          const m = String(b.title || '').match(/get\s+(\d+)/i);
          const get = m ? Math.min(+m[1], qty - 1) : 0;
          return { id: b.id, title: b.title, type: 'qb', buy: qty, get, units: qty, price: precio(b, qty), planId, gifts: regalos(b) };
        })
        .filter((b) => b.units > 0);
      // Un «Buy 2 + Get 1 FREE» cobra 2 unidades al precio que Kaching pone a UNA, no al precio de tarifa.
      const uno = bars.find((b) => b.units === 1 && b.price != null);
      const base = (uno && uno.price) || unit;
      bars.forEach((b) => { if (b.price == null) b.price = base * b.buy; });
      if (!bars.length || !d.nanoId || !d.versionId) return null;
      const plans = ((product && product.sellingPlans) || []).map((p) => ({ id: p.id, name: p.name, adj: p.priceAdjustment || null }));
      return { nanoId: d.nanoId, versionId: d.versionId, subscriptions: d.subscriptionsEnabled !== false, bars, plans, giftHandles: d.otherProductHandles || [] };
    }

    loadDeal(productId, handle) {
      const pid = String(productId);
      if (pid in this.deals) return Promise.resolve(this.deals[pid]);
      try {
        const ss = sessionStorage.getItem(DEAL_KEY + pid);
        if (ss) return Promise.resolve((this.deals[pid] = JSON.parse(ss)));
      } catch (e) {}
      if (!this.dealLoads[pid]) {
        this.dealLoads[pid] = fetch('/products/' + encodeURIComponent(handle) + '?view=sk-data', { headers: { Accept: 'text/html' } })
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            this.readDeals(doc);
            if (!(pid in this.deals)) {
              this.deals[pid] = null;
              try { sessionStorage.setItem(DEAL_KEY + pid, 'null'); } catch (e) {}
            }
            return this.deals[pid];
          })
          .catch(() => null)
          .finally(() => delete this.dealLoads[pid]);
      }
      return this.dealLoads[pid];
    }

    preloadDeals(cart) {
      const missing = this.paid(cart).filter((l) => !(String(l.product_id) in this.deals));
      if (!missing.length) return;
      Promise.all(missing.map((l) => this.loadDeal(l.product_id, l.handle))).then(() => this.cart && this.render(this.cart));
    }

    async product(handle) {
      if (this.productCache[handle]) return this.productCache[handle];
      const p = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      return (this.productCache[handle] = p);
    }

    /* Escalera de unidades: 1, 2, 3, 4… hasta el tope. Cada cantidad se arma con la combinación de packs
       MÁS BARATA, no con la que más unidades regala — que es lo que hacía antes y por eso bajar cantidad podía
       subir el precio (elegía 3-pack + 2 sueltas a 176 cuando había una forma más barata). Con packs cerrados
       de Kaching no hay milagro: si el 6-pack vale menos que cinco unidades sueltas, el aviso de debajo lo dice
       («añade 1 más y pagas menos»), pero la cantidad intermedia se permite igual: la elige la clienta. */
    ladder(deal) {
      if (deal._ladder && deal._ladderMax === this.cfg.maxUnits) return deal._ladder;
      const max = Math.max(+this.cfg.maxUnits || 30, 1);
      const bars = deal.bars.slice().sort((a, b) => a.units - b.units);
      const lines = (comp) => new Set(comp.map((b) => (b.type === 'bxgy' ? rid() : b.id))).size + comp.filter((b) => b.type === 'bxgy' && b.get).length;
      const best = [{ units: 0, price: 0, free: 0, comp: [] }];
      for (let n = 1; n <= max; n++) {
        let pick = null;
        bars.forEach((bar) => {
          const prev = bar.units <= n ? best[n - bar.units] : null;
          if (!prev) return;
          const cand = { units: n, price: prev.price + bar.price, free: prev.free + bar.get, comp: prev.comp.concat([bar]) };
          // más barato primero; a igual precio, el que deja menos líneas en el carrito
          if (!pick || cand.price < pick.price || (cand.price === pick.price && lines(cand.comp) < lines(pick.comp))) pick = cand;
        });
        best[n] = pick;
      }
      Object.defineProperty(deal, '_ladder', { value: best.slice(1).filter(Boolean), writable: true, configurable: true });
      Object.defineProperty(deal, '_ladderMax', { value: this.cfg.maxUnits, writable: true, configurable: true });
      return deal._ladder;
    }

    /* ---------- tarjetas por producto ---------- */
    groups(cart) {
      const out = [];
      const map = new Map();
      this.paid(cart).forEach((i) => {
        /* 2 oct 2026 · Una linea que Kaching marca como regalo ({"gift":..}) va en su PROPIO grupo,
           aunque sea la misma variante que una de pago. Asi la de regalo puede seguir a FREE mientras
           la de pago vive aparte con su precio: es lo que pasa al subir la cantidad de un regalo. */
        const kbL = this.kb(i);
        // 7 oct 2026 · Un regalo de pack se agrupa con SU pack (matrícula): el Eye Mask es regalo de la Face Mask y de las
        // Eye Patches, y sin esto dos packs se juntaban en una sola línea y el «−» podía tocar el regalo del otro pack.
        const key = i.variant_id + ':' + planOf(i) + (kbL && kbL.gift ? ':' + (kbL.id || '') + ':gift' : '');
        let g = map.get(key);
        if (!g) { g = { key, lines: [] }; map.set(key, g); out.push(g); }
        g.lines.push(i);
      });
      out.forEach((g) => {
        const main = g.lines.find((l) => { const k = this.kb(l); return !(k && k.bxgy); }) || g.lines[0];
        g.main = main;
        g.productId = main.product_id;
        g.variantId = main.variant_id;
        g.handle = main.handle;
        g.planId = planOf(main);
        g.subscribed = !!g.planId;
        g.units = g.lines.reduce((s, l) => s + l.quantity, 0);
        g.final = g.lines.reduce((s, l) => s + l.final_line_price, 0);
        g.compare = g.lines.reduce((s, l) => s + this.unitCompare(l) * l.quantity, 0);
        g.freeNow = g.lines.reduce((s, l) => s + (l.final_line_price === 0 && l.original_line_price > 0 ? l.quantity : 0), 0);
        const pid = String(g.productId);
        g.deal = pid in this.deals ? this.deals[pid] : undefined;
        if (g.deal) {
          // En packs de una sola línea no hay líneas a 0: las gratis se cuentan por el pack de cada línea.
          g.lines.forEach((l) => {
            const k = this.kb(l);
            const bar = k && k.bid && g.deal.bars.find((x) => x.id === k.bid && x.type === 'qb' && x.get > 0);
            if (bar) g.freeNow += Math.floor(l.quantity / bar.units) * bar.get;
          });
        }
        const offers = g.deal ? (g.deal.titles || g.deal.bars.filter((b) => b.get > 0 || b.units > 1).map((b) => b.title)) : null;
        const titles = [];
        g.lines.forEach((l) => (l.discounts || []).forEach((d) => {
          if (!d.title || titles.includes(d.title)) return;
          if (offers && !offers.includes(d.title)) return; // «Buy 1» y similares no son una oferta que enseñar
          titles.push(d.title);
        }));
        g.badges = titles;
      });
      return out;
    }
    unitCompare(l) {
      const spa = l.selling_plan_allocation;
      if (spa) return spa.compare_at_price || spa.price || l.original_price;
      return Math.max(l.original_price || 0, l.price || 0);
    }
    /* 6 oct 2026 · Packs de PACK_EXACTO: gratis que tocan a una cantidad = regalos de la barra más alta que cabe. */
    gratisDe(g, units) {
      const bar = (g.deal.bars || []).filter((b) => b.type === 'qb' && b.units <= units).sort((a, b) => b.units - a.units)[0];
      return bar && bar.gifts ? bar.gifts.filter((x) => !x.soloSub || g.planId).reduce((s, x) => s + x.qty, 0) : 0;
    }
    esExactoConRegalos(g) { return this.gratisDe(g, g.units) > 0; }
    esExacto(g) { const k = g && g.main && this.kb(g.main); return !!(k && PACK_EXACTO.includes(k.deal)); }
    steps(g) {
      if (!g.deal || g.deal.ab) return null;
      // Packs de PACK_EXACTO: «Add 1 more to get 1 FREE» desde 1, «Add 1 more to get 3 FREE» desde 2, y nada a
      // partir del pack más alto (cada caja vale lo mismo; solo cambian los regalos).
      if (this.esExacto(g)) {
        const ahora = this.gratisDe(g, g.units);
        const sig = (g.deal.bars || []).filter((b) => b.type === 'qb' && b.units > g.units).sort((a, b) => a.units - b.units)
          .find((b) => this.gratisDe(g, b.units) > ahora);
        const variosProductos = (g.deal.bars || []).some((b) => new Set((b.gifts || []).map((x) => x.pid)).size > 1);
        return { next: null, prev: null, tip: sig ? { units: sig.units, free: this.gratisDe(g, sig.units), extra: this.gratisDe(g, sig.units) - ahora, regalos: variosProductos } : null, exacto: true };
      }
      const all = this.ladder(g.deal);
      const u = g.units;
      const next = all.find((s) => s.units > u) || null;
      const prev = all.slice().reverse().find((s) => s.units < u) || null;
      // Primero, si subir unidades sale MÁS BARATO, se avisa de eso. Si no, del siguiente escalón con más regalos.
      const aqui = all.find((s) => s.units === u);
      const tip = (aqui ? all.find((s) => s.units > u && s.price < aqui.price) : null) ||
        all.find((s) => s.units > u && s.free > g.freeNow) || null;
      return { next, prev, tip };
    }

    lineFor(g, qty, props, plan) {
      const line = { id: g.variantId, quantity: qty, properties: { __kaching_bundles: JSON.stringify(props) } };
      const session = g.lines.map((l) => l.properties && l.properties.__kaching_session_id).find(Boolean);
      if (session) line.properties.__kaching_session_id = session;
      if (plan) line.selling_plan = plan.id;
      return line;
    }
    buildLines(g, deal, comp, plan) {
      const out = [];
      const pp = g.productId;
      const spProp = plan ? { sellingPlan: { id: plan.id, priceAdjustment: plan.adj || undefined } } : {};
      comp.forEach((bar) => {
        if (bar.type === 'bxgy') {
          const id = rid();
          out.push(this.lineFor(g, bar.buy, Object.assign({ deal: deal.nanoId, pp, main: true, v: deal.versionId, id, bar: bar.id }, spProp), plan));
          if (bar.get) out.push(this.lineFor(g, bar.get, { id, deal: deal.nanoId, bar: bar.id, v: deal.versionId, main: true, bxgy: true }, plan));
        } else {
          const props = Object.assign({ deal: deal.nanoId, pp, main: true, v: deal.versionId, bid: bar.id }, spProp);
          const same = out.find((l) => l.properties.__kaching_bundles === JSON.stringify(props));
          if (same) same.quantity += bar.buy;
          else out.push(this.lineFor(g, bar.buy, props, plan));
        }
      });
      return out;
    }

    /* Aplica la combinación nueva. Primero se quitan las líneas viejas y después se añaden las nuevas: al añadir un
       pack, Kaching reparte las líneas y Shopify les cambia la clave, así que borrar después por clave falla.
       Si el añadido falla, se restauran las líneas de antes para que la clienta no pierda nada. */
    async applyLines(g, newLines) {
      // Kaching rehace el carrito y CAMBIA las claves de línea, así que comprobar el borrado por clave no vale:
      // la línea sigue viva pero con otra clave y el borrado falla en silencio. Se mira por producto, y se
      // reintenta con las claves nuevas hasta tres veces.
      const mismas = (c) => ((c && c.items) || []).filter((i) => i.variant_id === g.variantId && planOf(i) === g.planId);
      let tras = null;
      for (let intento = 0; intento < 3; intento++) {
        const previas = intento === 0 ? g.lines : mismas(tras);
        if (!previas.length) break;
        const updates = {};
        previas.forEach((l) => (updates[l.key] = 0));
        tras = await post('/cart/update.js', { updates });
      }
      // Si aún queda alguna unidad viva, NO se añade nada: añadir encima duplicaría el pack y cobraría de más.
      if (mismas(tras).length) return this.sync(tras);
      try {
        await post('/cart/add.js', { items: newLines });
      } catch (err) {
        const restore = g.lines.map((l) => {
          const it = { id: l.variant_id, quantity: l.quantity, properties: l.properties || {} };
          if (planOf(l)) it.selling_plan = planOf(l);
          return it;
        });
        await post('/cart/add.js', { items: restore }).catch(() => {});
        throw err;
      }
      return this.sync();
    }

    async freshGroup(groupKey) {
      // Siempre se relee: el «Add to cart» de la ficha es de Kaching, va por su cuenta y puede estar todavía
      // rehaciendo el carrito cuando la clienta pulsa + o −. Con el carrito viejo las claves ya no existen.
      const cart = await getCart();
      const g = this.groups(cart).find((x) => x.key === groupKey);
      if (g && g.deal === undefined) { await this.loadDeal(g.productId, g.handle); g.deal = this.deals[String(g.productId)]; }
      return g;
    }

    /* 2 oct 2026 · Subir o bajar un regalo del pack.
       «+» NO toca la linea de regalo: añade una unidad del mismo producto SIN las propiedades de Kaching,
       que cae en su propio grupo y se cobra normal. «−» baja las unidades gratis con change.js, que
       conserva las propiedades y por tanto el descuento. */
    async giftStep(groupKey, dir) {
      const cart = await getCart();
      const g = this.groups(cart).find((x) => x.key === groupKey);
      if (!g) return this.sync();
      if (dir > 0) {
        if (g.units >= this.maxUnits()) return this.sync(cart);
        /* 6 oct 2026 · Regla de Victor (packs de PACK_EXACTO): si aún le toca alguna gratis, el «+» la devuelve gratis
           subiendo la línea de regalo; solo cuando ya tiene todas las que le tocan entra una unidad suelta de pago. */
        /* 27 oct 2026 · Regla de Victor: el «+» de un regalo de pack SOLO devuelve regalos gratis hasta los que da la oferta
           de Kaching para ese pack (lo que se quitó con «−» vuelve gratis). Nunca añade la copia de pago (era la puerta P2
           de auditorias/copias-regalo-cobradas-27oct.md: «si ya tiene todos, entra de pago suelto») ni el ®. Si ya tiene
           todos, el «+» ni se pinta (puedeMasRegalo). */
        /* 27 oct 2026 (noche) · Victor: «si quieren añadir más, que les salga de pago». Si aún le toca alguno gratis
           según su pack, el «+» lo devuelve gratis; si ya tiene todos, entra una unidad suelta de pago, como el 6 oct. */
        const l0 = g.lines[0];
        if (this.puedeMasRegalo(cart, l0)) return this.sync(await post('/cart/change.js', { id: l0.key, quantity: l0.quantity + 1, properties: Object.assign({}, l0.properties || {}) }));
        await post('/cart/add.js', { items: [{ id: g.variantId, quantity: 1 }] });
        return this.sync();
      }
      if (g.units <= 1) return this.removeKeys(g.lines.map((l) => l.key));
      // 6 oct 2026 · Resta UNA unidad del total. Antes se ponía la primera línea a «total − 1», y con dos líneas de
      // regalo (1 + 2) eso SUBÍA la primera a 2: el «−» no bajaba. Se baja la última línea, o se quita si tiene 1.
      const l = g.lines[g.lines.length - 1];
      if (l.quantity <= 1) return this.removeKeys([l.key]);
      return this.sync(await post('/cart/change.js', { id: l.key, quantity: l.quantity - 1, properties: Object.assign({}, l.properties || {}) }));
    }

    async setUnits(groupKey, units, reintento, sinSync) {
      const g = await this.freshGroup(groupKey);
      if (!g) return this.sync();
      if (units <= 0) return this.removeKeys(g.lines.map((l) => l.key));
      if (units === g.units) return sinSync ? null : this.sync();
      const cart = await this.replacePlain(g, units, g.planId, sinSync);
      // Kaching reinyecta su pack por su cuenta y a veces cae justo en medio del cambio. Si el carrito no ha
      // acabado en el número pedido, se corrige UNA vez — una sola, para no entrar en bucle.
      if (!reintento) {
        const g2 = cart && cart.items ? this.groups(cart).find((x) => x.key === groupKey) : null;
        if ((g2 ? g2.units : 0) !== units) return this.setUnits(groupKey, units, true, sinSync);
      }
      return cart;
    }

    /* ---------- escribir un producto: el carrito NO elige packs ----------
       Cambiar cantidad o plan = se quitan las líneas del producto y se escribe de nuevo con el CONTEXTO de Kaching
       (deal, versión y variante del test A/B, copiados de la propia línea) pero SIN pack. La función de Kaching
       elige sola el pack que toca a esa cantidad, sea BOGO, quantity break o lo que venga, y aplica encima el plan
       de suscripción. Comprobado el 18 sep 2026 con las dos variantes del test de la mascarilla de cara.
       Única excepción: suscripción + BOGO. Ahí su función no reparte las gratis, así que se escribe como lo hace su
       widget — el BOGO más grande que quepa, pagadas + gratis —, que es justo el que elige ella en compra única. */
    kctx(g) {
      const pid = String(g.productId);
      for (const l of g.lines) {
        const k = this.kb(l);
        if (k && k.deal && k.v) {
          const c = { deal: k.deal, pp: k.pp || g.productId, main: true, v: k.v };
          if (k.abid) { c.abid = k.abid; c.ab = k.ab; }
          this.kctxCache[pid] = c;
          try { sessionStorage.setItem('skc-kctx-' + pid, JSON.stringify(c)); } catch (e) {}
          return c;
        }
      }
      if (this.kctxCache[pid]) return this.kctxCache[pid];
      try { const s = sessionStorage.getItem('skc-kctx-' + pid); if (s) return (this.kctxCache[pid] = JSON.parse(s)); } catch (e) {}
      return null;
    }
    bxgyFor(g, ctx) {
      const vs = (g.deal && g.deal.variants) || [];
      const v = (ctx && ctx.abid && vs.find((x) => x.abid === ctx.abid)) || (vs.length === 1 ? vs[0] : null);
      return v ? v.bxgy : [];
    }
    async planAdj(g, planId) {
      try {
        const prod = await this.product(g.handle);
        const sp = (prod.selling_plan_groups || []).flatMap((x) => x.selling_plans).find((x) => x.id === planId);
        const a = sp && sp.price_adjustments && sp.price_adjustments[0];
        return a ? { type: a.value_type, value: a.value } : undefined;
      } catch (e) { return undefined; }
    }
    async productLines(g, units, planId) {
      const ctx = this.kctx(g);
      const session = g.lines.map((l) => l.properties && l.properties.__kaching_session_id).find(Boolean);
      const plan = (it) => { if (planId) it.selling_plan = planId; return it; };
      if (!ctx) return [plan({ id: g.variantId, quantity: units })]; // producto sin Kaching
      const k = Object.assign({}, ctx);
      if (planId) k.sellingPlan = { id: planId, priceAdjustment: await this.planAdj(g, planId) };
      const line = (qty, props) => {
        const it = { id: g.variantId, quantity: qty, properties: { __kaching_bundles: JSON.stringify(props) } };
        if (session && props.main && !props.bxgy) it.properties.__kaching_session_id = session;
        return plan(it);
      };
      if (planId) {
        const bar = this.bxgyFor(g, ctx).find((b) => b.units <= units);
        if (bar) {
          const iid = rid();
          const free = { id: iid, deal: ctx.deal, bar: bar.id, v: ctx.v, main: true, bxgy: true };
          if (ctx.abid) { free.abid = ctx.abid; free.ab = ctx.ab; }
          return [line(units - bar.get, Object.assign({}, k, { id: iid, bar: bar.id })), line(bar.get, free)];
        }
      }
      return [line(units, k)];
    }
    /* ---------- cambiar la linea EN SU SITIO (2 oct 2026) ----------
       Borrar la linea y volver a crearla deja huerfanos los regalos del pack —son lineas aparte con
       {"id":<matricula>,"gift":..} apuntando a la principal— y Kaching los barre en ese hueco. Pasaba al
       suscribirse Y al cambiar cantidad. /cart/change.js modifica la linea sin borrarla, asi que conserva
       la matricula y los regalos no se mueven; pasandole ademas las propiedades con el bloque sellingPlan,
       Kaching sigue viendo su pack y cobra el precio de pack con suscripcion.
       Comprobado el 2 oct: 3 mascarillas $132 + 3 regalos -> $99 con plan + los 3 regalos intactos.
       Solo se usa cuando el grupo es UNA linea con matricula; en cualquier otro caso se hace como siempre. */
    async cambiarEnSitio(g, units, planId) {
      if (g.lines.length !== 1 || units <= 0) return null;
      const l = g.lines[0];
      const kb = this.kb(l);
      if (!kb || !kb.id) return null; // sin matricula no hay regalos enganchados que proteger
      const nuevo = Object.assign({}, kb);
      if (planId) nuevo.sellingPlan = { id: planId, priceAdjustment: await this.planAdj(g, planId) };
      else delete nuevo.sellingPlan;
      const props = Object.assign({}, l.properties || {});
      props.__kaching_bundles = JSON.stringify(nuevo);
      const body = { id: l.key, quantity: units, properties: props };
      body.selling_plan = planId || null; // null quita el plan
      return post('/cart/change.js', body);
    }

    async replacePlain(g, units, planId, sinSync) {
      const enSitio = await this.cambiarEnSitio(g, units, planId).catch(() => null);
      if (enSitio && enSitio.items) return sinSync ? enSitio : this.sync(enSitio);
      return this.applyLines(g, await this.productLines(g, units, planId));
    }

    planById(g, id) {
      const p = g.deal && g.deal.plans.find((x) => x.id === id);
      return { id, adj: p ? p.adj : null, name: p ? p.name : '' };
    }

    /* Plan que se ofrece al suscribir: el del pack en Kaching; si el producto no tiene Kaching, el primero de Shopify. */
    async offerPlan(g) {
      if (g.deal) {
        if (!g.deal.plans.length) return null;
        const barPlan = (g.deal.bars.find((b) => b.planId) || {}).planId;
        const p = g.deal.plans.find((x) => x.id === barPlan) || g.deal.plans[0];
        return { id: p.id, adj: p.adj, name: p.name };
      }
      const prod = await this.product(g.handle);
      const sp = (prod.selling_plan_groups || []).flatMap((x) => x.selling_plans)[0];
      if (!sp) return null;
      const a = sp.price_adjustments && sp.price_adjustments[0];
      return { id: sp.id, name: sp.name, adj: a ? { type: a.value_type, value: a.value } : null };
    }
    offerPlanSync(g) {
      if (g.deal) {
        if (!g.deal.subscriptions || !g.deal.plans.length) return null;
        const barPlan = (g.deal.bars.find((b) => b.planId) || {}).planId;
        const p = g.deal.plans.find((x) => x.id === barPlan) || g.deal.plans[0];
        return { id: p.id, adj: p.adj, name: p.name };
      }
      const prod = this.productCache[g.handle];
      if (!prod) { if (g.deal === null) this.product(g.handle).then(() => this.render(this.cart)).catch(() => {}); return null; }
      const sp = (prod.selling_plan_groups || []).flatMap((x) => x.selling_plans)[0];
      if (!sp) return null;
      const a = sp.price_adjustments && sp.price_adjustments[0];
      return { id: sp.id, name: sp.name, adj: a ? { type: a.value_type, value: a.value } : null };
    }

    async subscribeGroup(groupKey) {
      const g = await this.freshGroup(groupKey);
      if (!g) return this.sync();
      const plan = await this.offerPlan(g);
      if (!plan) throw new Error(this.cfg.texts.noSubscription || 'This product has no subscription option.');
      const cart = await this.replacePlain(g, g.units, plan.id);
      if (await this.packExacto(g.productId).catch(() => false)) return this.sync();
      return cart;
    }

    /* 6 oct 2026 · Regla de Victor: después de cualquier «+», «−» o suscripción hecho en el carrito, el pack queda
       IGUAL que si se hubiera elegido esa barra en la ficha: los regalos de la barra que toca a la cantidad, gratis y
       en su número exacto. Los que faltan se ponen; los que sobran (gratis o ya de pago) se quitan.
       Antes, bajar de 3+3 a 2 en las Eye Patches dejaba 2 Eye Masks de regalo cobrándose ($117 → $156), y subir de
       2+1 a 3 dejaba 1 gratis con «Buy 3 + Get 3 FREE». Solo para los deals de PACK_EXACTO y con UNA línea principal.
       Devuelve true si ha escrito algo. */
    async packExacto(productId, conocido, soloSobra) {
      const pid = String(productId);
      let cart = conocido && conocido.items ? conocido : await getCart();
      const esMain = (i) => { const x = this.kb(i); return String(i.product_id) === pid && x && x.main && !x.gift && !x.bxgy; };
      const mains = cart.items.filter(esMain);
      if (mains.length !== 1) return false;
      const main = mains[0];
      const k = this.kb(main);
      if (!PACK_EXACTO.includes(k.deal)) return false;
      const deal = pid in this.deals ? this.deals[pid] : await this.loadDeal(pid, main.handle);
      if (!deal || deal.ab || k.deal !== deal.nanoId) return false;
      const bar = deal.bars.filter((b) => b.type === 'qb').sort((a, b) => b.units - a.units).find((b) => b.units <= main.quantity);
      if (!bar) return false;
      const plan = planOf(main);
      const want = (bar.gifts || []).filter((x) => !x.soloSub || plan);
      const mat = k.id || rid();
      const mios = cart.items.filter((i) => { const g = this.kb(i); return g && g.gift && g.deal === deal.nanoId && k.id && g.id === k.id; });
      const updates = {};
      const faltan = [];
      // Por producto de regalo: se deja exactamente la cantidad de la barra. Al recortar, primero lo que se cobra.
      const pids = new Set(mios.map((i) => String(i.product_id)).concat(want.map((x) => String(x.pid))));
      pids.forEach((p) => {
        const objetivo = want.filter((x) => String(x.pid) === p).reduce((s, x) => s + x.qty, 0);
        const lineas = mios.filter((i) => String(i.product_id) === p).sort((a, b) => b.final_line_price - a.final_line_price);
        let tiene = lineas.reduce((s, i) => s + i.quantity, 0);
        lineas.forEach((l) => {
          if (tiene <= objetivo) return;
          const quita = Math.min(l.quantity, tiene - objetivo);
          updates[l.key] = l.quantity - quita;
          tiene -= quita;
        });
        if (tiene < objetivo && !soloSobra) {
          // Una sola línea por regalo: si ya hay alguna (p. ej. la de 1 del 2+1), se quita y se escribe una con la
          // cantidad entera de la barra nueva. Con dos líneas el «−» del regalo actuaba sobre la que no era.
          const x = want.find((w) => String(w.pid) === p);
          lineas.forEach((l) => { if (updates[l.key] == null || updates[l.key] > 0) updates[l.key] = 0; });
          faltan.push({ gid: x.gid, pid: x.pid, qty: objetivo });
        }
      });
      // Sin matrícula hay que ponérsela (los regalos se atan a ella). Con matrícula, cambiar «bid» no hace falta:
      // la función de Kaching cobra el pack por cantidad (visto el 5 oct en la Face Mask). Ahorra dos llamadas.
      const reetiquetar = !k.id && !soloSobra;
      if (!Object.keys(updates).length && !faltan.length && !reetiquetar) return false;
      if (Object.keys(updates).length) await postRaw('/cart/update.js', { updates });
      if (faltan.length) {
        await this.giftVariants(deal, faltan.map((x) => x.pid), cart);
        const items = [];
        for (const x of faltan) {
          const vid = await this.giftVariant(deal, x.pid, cart);
          if (vid) items.push({ id: vid, quantity: x.qty, properties: { __kaching_bundles: JSON.stringify({ id: mat, deal: deal.nanoId, v: k.v || deal.versionId, gift: x.gid }) } });
        }
        if (items.length) await postRaw('/cart/add.js', { items });
      }
      if (reetiquetar) {
        // Kaching rehace el carrito y cambia las claves: la línea se busca de nuevo en cada intento.
        for (let intento = 0; intento < 3; intento++) {
          const c = await getCart();
          const m = c.items.filter(esMain);
          if (m.length !== 1) break;
          const km = this.kb(m[0]);
          if (km.id === mat && km.bid === bar.id) break;
          const props = Object.assign({}, m[0].properties || {});
          const nuevo = Object.assign({}, km, { id: mat, bid: bar.id });
          delete nuevo.bar;
          props.__kaching_bundles = JSON.stringify(nuevo);
          try { await postRaw('/cart/change.js', { id: m[0].key, quantity: m[0].quantity, properties: props, selling_plan: planOf(m[0]) || null }); break; } catch (e) {}
        }
      }
      return true;
    }
    /* 27 oct 2026 · Los packs del carrito con lo que les TOCA según la oferta de Kaching (barra más alta que cabe en la
       cantidad de la línea principal; regalos «solo suscripción» solo si va suscrita) y lo que TIENEN, por producto
       regalo. Solo deals de PACK_EXACTO con el deal ya cargado (sin red: se usa al pintar). */
    packsDeCarrito(cart) {
      const out = [];
      ((cart && cart.items) || []).forEach((m) => {
        const k = this.kb(m);
        if (!k || !k.main || k.gift || k.bxgy || !k.id || !PACK_EXACTO.includes(k.deal)) return;
        const deal = this.deals[String(m.product_id)];
        if (!deal || deal.ab || deal.nanoId !== k.deal) return;
        const bar = deal.bars.filter((b) => b.type === 'qb').sort((a, b) => b.units - a.units).find((b) => b.units <= m.quantity);
        const plan = planOf(m);
        const toca = {};
        ((bar && bar.gifts) || []).filter((x) => !x.soloSub || plan).forEach((x) => { toca[x.pid] = (toca[x.pid] || 0) + x.qty; });
        const tiene = {};
        cart.items.forEach((i) => { const gk = this.kb(i); if (gk && gk.gift && gk.id === k.id) tiene[i.product_id] = (tiene[i.product_id] || 0) + i.quantity; });
        out.push({ id: k.id, main: m, units: m.quantity, toca, tiene, falta: Object.keys(toca).some((p) => !(tiene[p] > 0)) }); // regalo quitado del todo (si solo bajó, vuelve con su «+»)
      });
      return out;
    }
    /* ¿Le queda algún regalo gratis de ese producto en su pack? (el «+» de la línea de regalo) */
    puedeMasRegalo(cart, giftLine) {
      const g = this.kb(giftLine);
      const pk = g && g.gift && this.packsDeCarrito(cart).find((x) => x.id === g.id);
      return !!(pk && (pk.tiene[giftLine.product_id] || 0) < (pk.toca[giftLine.product_id] || 0));
    }
    /* 27 oct 2026 · Los tramos de regalo del personalizador para la pieza del checkout (atributo `_sk_tiers`): clave, variante,
       importe en USD (`min`, el mismo que va en `_sk_gift_min`) y ya convertido a la moneda del carrito (`c`, céntimos).
       El personalizador sigue siendo el único sitio donde se cambian. */
    tiersAttr(cart) {
      const t = (this.cfg.tiers || []).filter((x) => x.on && x.type === 'gift' && x.gift && x.gift.variantId && +x.threshold > 0)
        .map((x) => ({ k: x.key, v: +x.gift.variantId, min: +x.threshold, c: this.thresholdCents(x) }));
      return JSON.stringify({ cur: cart.currency, below: this.cfg.giftBelow || 'keep', t });
    }
    /* Para la función de descuento y la extensión del checkout (atributo `_sk_packs`): cuántas unidades gratis de cada
       producto da cada pack, con la cantidad de su línea principal. Si en el checkout la cantidad no cuadra, deciden sin esto. */
    packsAttr(cart) {
      const o = {};
      this.packsDeCarrito(cart).forEach((pk) => { o[pk.id] = { u: pk.units, g: pk.toca }; });
      return Object.keys(o).length ? JSON.stringify(o) : '';
    }
    /* Cuántas unidades gratis de ese producto le tocan a la línea principal de su matrícula (packs de PACK_EXACTO). */
    async regalosQueTocan(giftLine) {
      const g = this.kb(giftLine);
      if (!g || !g.gift || !PACK_EXACTO.includes(g.deal)) return null;
      const cart = await getCart();
      const main = cart.items.find((i) => { const x = this.kb(i); return x && x.main && !x.gift && !x.bxgy && x.id === g.id; });
      if (!main) return null;
      const deal = String(main.product_id) in this.deals ? this.deals[String(main.product_id)] : await this.loadDeal(main.product_id, main.handle);
      if (!deal) return null;
      const bar = deal.bars.filter((b) => b.type === 'qb').sort((a, b) => b.units - a.units).find((b) => b.units <= main.quantity);
      if (!bar || !bar.gifts) return 0;
      const plan = planOf(main);
      return bar.gifts.filter((x) => String(x.pid) === String(giftLine.product_id) && (!x.soloSub || plan)).reduce((s, x) => s + x.qty, 0);
    }
    /* Variante del producto regalo. Kaching solo da el ID del producto, y su lista de handles no siempre lo trae (en
       las Eye Patches apunta a otro producto). Orden: una línea del carrito de ese producto → los handles del deal →
       la Storefront API pública por ID (sin clave; comprobado el 6 oct con collagen-eye-patches-free). */
    /* 7 oct 2026 · Las variantes de los regalos que faltan, de una vez: carrito → lo guardado en la visita
       (sessionStorage) → UNA consulta a la Storefront API para el resto. Antes eran fichas pedidas una detrás de otra. */
    async giftVariants(deal, pids, cartLeido) {
      this.giftVariantCache = this.giftVariantCache || {};
      const falta = [];
      for (const p of pids.map(String)) {
        if (this.giftVariantCache[p]) continue;
        const l = cartLeido && cartLeido.items.find((i) => String(i.product_id) === p);
        if (l) { this.giftVariantCache[p] = l.variant_id; continue; }
        try { const v = sessionStorage.getItem('skc-giftvar-' + p); if (v) { this.giftVariantCache[p] = +v; continue; } } catch (e) {}
        falta.push(p);
      }
      if (!falta.length) return;
      try {
        const q = '{ nodes(ids:[' + falta.map((p) => '"gid://shopify/Product/' + p + '"').join(',') + ']){ ... on Product { id variants(first:5){ nodes{ id availableForSale } } } } }';
        const r = await rawFetch('/api/2025-07/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: q }) }).then((x) => x.json());
        ((r && r.data && r.data.nodes) || []).forEach((n) => {
          if (!n || !n.id) return;
          const vs = (n.variants && n.variants.nodes) || [];
          const v = vs.find((x) => x.availableForSale) || vs[0];
          if (!v) return;
          const p = String(n.id).split('/').pop(), id = +String(v.id).split('/').pop();
          this.giftVariantCache[p] = id;
          try { sessionStorage.setItem('skc-giftvar-' + p, String(id)); } catch (e) {}
        });
      } catch (e) {}
    }
    async giftVariant(deal, productId, cartLeido) {
      this.giftVariantCache = this.giftVariantCache || {};
      const pid = String(productId);
      if (this.giftVariantCache[pid]) return this.giftVariantCache[pid];
      const guarda = (v) => (v ? (this.giftVariantCache[pid] = v) : null);
      try {
        const c = cartLeido || (await getCart());
        const l = c.items.find((i) => String(i.product_id) === pid);
        if (l) return guarda(l.variant_id);
      } catch (e) {}
      for (const h of deal.giftHandles || []) {
        try {
          const p = await this.product(h);
          if (p && String(p.id) === pid) {
            const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0];
            if (v) return guarda(v.id);
          }
        } catch (e) {}
      }
      try {
        const r = await rawFetch('/api/2025-07/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ query: '{ node(id:"gid://shopify/Product/' + pid + '"){ ... on Product { variants(first:5){ nodes{ id availableForSale } } } } }' }),
        }).then((x) => x.json());
        const vs = (r && r.data && r.data.node && r.data.node.variants && r.data.node.variants.nodes) || [];
        const v = vs.find((x) => x.availableForSale) || vs[0];
        if (v) return guarda(+String(v.id).split('/').pop());
      } catch (e) {}
      return null;
    }

    /* ---------- render ---------- */
    money(cents) {
      const fmt = this.cfg.moneyFormat || '${{amount}}';
      const n = (cents || 0) / 100;
      const withDelim = (num, dec, th, ds) => {
        const parts = num.toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return parts.join(ds);
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        switch (k) {
          case 'amount_no_decimals': return withDelim(n, 0, ',', '.');
          case 'amount_with_comma_separator': return withDelim(n, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withDelim(n, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return withDelim(n, 2, "'", '.');
          default: return withDelim(n, 2, ',', '.');
        }
      });
    }
    img(src, w) {
      if (!src) return '';
      return String(src) + (String(src).includes('?') ? '&' : '?') + 'width=' + (w || 160);
    }

    render(cart) {
      if (!cart) return;
      const paid = this.paid(cart);
      const giftLines = cart.items.filter((i) => this.isGift(i) && (paid.length || !this.isPromo(i)));
      const empty = !paid.length && !giftLines.length;
      this.classList.toggle('is-empty', empty);
      this.$('[data-skc-empty]').hidden = !empty;
      this.$('[data-skc-foot]').hidden = empty;
      // Cuentan los productos de pago y los regalos que se están cobrando (los gratis no).
      const units = paid.reduce((s, i) => s + i.quantity, 0) + giftLines.filter((i) => !this.giftIsFree(cart, i, this.giftTier(i))).reduce((s, i) => s + i.quantity, 0);
      this.$('[data-skc-count]').textContent = empty ? '' : '(' + units + ')';
      this.updateHeader(units);

      this.renderRewards(cart, empty);
      this.$('[data-skc-items]').innerHTML = empty ? '' : this.ordenGrupos(cart, this.groups(cart)).map((g) => this.groupHtml(g)).join('');
      Object.keys(this.targets || {}).forEach((k) => this.pendingUnits(k, this.targets[k]));
      this.$('[data-skc-gifts]').innerHTML = empty ? '' : this.giftsHtml(cart);
      this.renderUpsell(cart);
      this.renderFooter(cart);
    }

    /* 7 oct 2026 · Orden de las líneas (petición de Victor): cada producto de pago en el orden en que se añadió (Shopify
       devuelve el último primero) y, justo debajo, sus regalos de pack (misma matrícula). Lo que no cuelga de ningún pack
       va al final. Solo cambia cómo se pinta: no escribe nada en el carrito. */
    ordenGrupos(cart, gs) {
      const pos = new Map(cart.items.map((i, n) => [i.key, n]));
      const antiguedad = (g) => Math.max(...g.lines.map((l) => pos.get(l.key) || 0)); // mayor índice = añadido antes
      const esRegaloPack = (g) => /:gift$/.test(g.key);
      const matDe = (g) => { for (const l of g.lines) { const k = this.kb(l); if (k && k.id) return k.id; } return null; };
      const pagos = gs.filter((g) => !esRegaloPack(g)).sort((a, b) => antiguedad(b) - antiguedad(a));
      const regalos = gs.filter(esRegaloPack).sort((a, b) => antiguedad(b) - antiguedad(a));
      const usados = new Set();
      const out = [];
      pagos.forEach((g) => {
        out.push(g);
        const k = this.kb(g.main);
        if (!k || !k.main || !k.id) return;
        regalos.forEach((r) => { if (!usados.has(r) && matDe(r) === k.id) { out.push(r); usados.add(r); } });
      });
      regalos.forEach((r) => { if (!usados.has(r)) out.push(r); });
      return out;
    }

    updateHeader(units) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      let b = bubble.querySelector('.cart-count-bubble');
      if (!units) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; bubble.appendChild(b); }
      b.innerHTML = '<span aria-hidden="true">' + units + '</span><span class="visually-hidden">' + units + (units === 1 ? ' item' : ' items') + '</span>';
    }

    renderRewards(cart, empty) {
      const el = this.$('[data-skc-rewards]');
      const tiers = (this.cfg.tiers || []).filter((t) => t.on && +t.threshold > 0).sort((a, b) => a.threshold - b.threshold);
      if (!this.cfg.rewards || empty || !tiers.length) { el.hidden = true; return; }
      el.hidden = false;
      const total = this.qualifying(cart);
      let fill = 0, prevT = 0, prevP = 0;
      const n = tiers.length;
      for (let i = 0; i < n; i++) {
        const th = this.thresholdCents(tiers[i]);
        const cp = ((i + 1) / n) * 100;
        if (total >= th) { fill = cp; prevT = th; prevP = cp; continue; }
        const span = th - prevT;
        fill = prevP + (span > 0 ? Math.max(0, (total - prevT) / span) : 0) * (cp - prevP);
        break;
      }
      const next = tiers.find((t) => total < this.thresholdCents(t));
      const msg = next
        ? esc(this.cfg.rewardsPending).replace('{amount}', '<strong>' + this.money(this.thresholdCents(next) - total) + '</strong>').replace('{reward}', '<strong>' + esc(next.label) + '</strong>')
        : esc(this.cfg.rewardsDone);
      const steps = tiers.map((t, i) => {
        const done = total >= this.thresholdCents(t);
        return '<li class="skc__step' + (done ? ' is-done' : '') + '" style="left:' + ((i + 1) / n) * 100 + '%"><span class="skc__step-dot">' + (done ? ICONS.check : ICONS[t.icon] || ICONS.gift) + '</span><span class="skc__step-label">' + esc(t.label) + '</span></li>';
      }).join('');
      const prev = el.querySelector('.skc__fill');
      const from = prev ? prev.style.width : '0%';
      el.innerHTML = '<p class="skc__rewards-msg">' + msg + '</p><div class="skc__track"><div class="skc__fill" style="width:' + from + '"></div><ol class="skc__steps" role="list">' + steps + '</ol></div>';
      requestAnimationFrame(() => requestAnimationFrame(() => { const f = el.querySelector('.skc__fill'); if (f) f.style.width = Math.min(100, fill) + '%'; }));
    }

    subscribeLabel(plan) {
      const txt = this.cfg.subscribeText || '';
      const pct = plan && plan.adj && plan.adj.type === 'percentage' ? Math.round(plan.adj.value) : null;
      return pct != null ? txt.replace(/\{percent\}/g, pct) : txt.replace(/\s*\{percent\}%?/g, '');
    }
    subscribedLabel(g) {
      const mode = this.cfg.subscribedMode || 'hidden';
      if (mode === 'hidden') return '';
      if (mode === 'custom') return this.cfg.subscribedText || '';
      const spa = g.main.selling_plan_allocation;
      return (spa && spa.selling_plan && spa.selling_plan.name) || '';
    }

    groupHtml(g) {
      const c = this.cfg;
      const m = g.main;
      const gk = esc(g.key);
      const title = esc(m.product_title);
      const titleHtml = c.linkTitles ? '<a class="skc__name" href="' + esc(m.url) + '">' + title + '</a>' : '<p class="skc__name">' + title + '</p>';
      const img = m.image ? '<img src="' + esc(this.img(m.image, 200)) + '" alt="" width="84" height="84" loading="lazy">' : '';
      const keys = esc(g.lines.map((l) => l.key).join(','));
      const compare = c.lineCompare && g.compare > g.final ? '<s class="skc__compare">' + this.money(g.compare) + '</s>' : '';
      const badges = c.lineBadge !== false && g.badges.length ? '<div class="skc__badges">' + g.badges.map((b) => '<span class="skc__badge">' + ICONS.tag + esc(b) + '</span>').join('') + '</div>' : '';
      const vt = m.variant_title || (m.options_with_values || []).map((o) => o.value).join(' / ');
      const variantHtml = c.variantName && vt && vt !== 'Default Title' ? '<p class="skc__variant">' + esc(vt) + '</p>' : '';
      const subbedTxt = g.subscribed ? this.subscribedLabel(g) : '';
      const subbed = subbedTxt ? '<p class="skc__subbed">' + ICONS.refill + esc(subbedTxt) + '</p>' : '';

      const st = this.steps(g); // sólo para el consejo de packs; los botones no dependen de él
      const dis = (on) => (on ? '' : ' disabled');
      /* 2 oct 2026 · Una línea de regalo NO lleva selector de cantidad. Subirla rompía el pack de Kaching
         y se cobraba la línea entera, así que la clienta perdía el regalo por darle al «+» (pedido #115485,
         £62 de más). Mismo criterio de «es gratis» que usan freeNow y giftIsFree. */
      const esRegalo = g.lines.length > 0 && g.lines.every((l) => l.final_line_price === 0 && l.original_line_price > 0);
      /* 2 oct 2026 · Un regalo de pack se pinta IGUAL que uno de umbral (icono de regalo, nota debajo,
         FREE y papelera a la derecha): antes iban por pintores distintos y se veían incoherentes.
         Y enseña su cantidad: en las eye patches el regalo son 3 unidades en UNA linea, y al quitar el
         selector se quedaba muda, sin decir cuantas eran. */
      if (esRegalo) {
        /* El selector de un regalo NO mueve la linea de regalo: subir su cantidad le quita el descuento
           de Kaching y se cobraria entera (pedido #115485, £62 de mas). El «+» añade una unidad SUELTA
           de pago en otra linea; el «−» si baja las gratis, que a nosotros nos ahorra envio. */
        // 27 oct 2026: el «+» solo si aún le queda algún regalo gratis de ese producto en su pack
        const mas = this.puedeMasRegalo(this.cart, m);
        const sel = '<div class="skc__qty skc__qty--gift">' +
          '<button type="button" class="skc__qty-b" data-skc-gift-step="-1" data-group="' + gk + '" aria-label="' + esc(c.texts.fewer || 'Fewer') + '">' + ICONS.minus + '</button>' +
          '<span class="skc__qty-v">' + g.units + '</span>' +
          '<button type="button" class="skc__qty-b" data-skc-gift-step="1" data-group="' + gk + '" aria-label="' + esc(c.texts.more || 'More') + '"' + (mas ? '' : ' title="' + esc('Add one more (paid)') + '"') + '>' + ICONS.plus + '</button>' + '</div>';
        return '<div class="skc__line skc__line--gift" data-group="' + gk + '">' +
          '<div class="skc__img">' + img + '<span class="skc__gift-ico">' + ICONS.gift + '</span></div>' +
          '<div class="skc__info">' + titleHtml + badges + '</div>' +
          '<div class="skc__price">' +
            (g.compare > 0 ? '<s class="skc__compare">' + this.money(g.compare) + '</s>' : '') +
            '<strong class="skc__free">' + esc(c.freeLabel || 'FREE') + '</strong>' +
          '</div>' +
          '<div class="skc__extra"><div class="skc__row">' + sel +
            '<button type="button" class="skc__remove" data-skc-remove data-keys="' + keys + '" aria-label="' + esc(c.texts.remove) + '">' + ICONS.trash + '</button>' +
          '</div></div>' +
        '</div>';
      }
      const qty = '<div class="skc__qty">' +
        '<button type="button" class="skc__qty-b" data-skc-step="-1" data-group="' + gk + '" aria-label="' + esc(c.texts.fewer || 'Fewer') + '">' + ICONS.minus + '</button>' +
        '<span class="skc__qty-v">' + g.units + '</span>' +
        '<button type="button" class="skc__qty-b" data-skc-step="1" data-group="' + gk + '"' + dis(g.units < this.maxUnits()) + ' aria-label="' + esc(c.texts.more || 'More') + '">' + ICONS.plus + '</button></div>';

      let sub = '';
      if (!g.subscribed && c.subscribe) {
        const plan = this.offerPlanSync(g);
        if (plan) sub = '<button type="button" class="skc__subscribe" data-skc-subscribe data-group="' + gk + '"><span class="skc__subscribe-hand">' + ICONS.hand + '</span><span class="skc__subscribe-t">' + esc(this.subscribeLabel(plan)) + '</span>' + ICONS.arrow + '</button>';
      }
      let tip = '';
      if (st && st.tip && (c.bundleTips || st.exacto)) {
        const count = st.tip.units - g.units;
        // Regalos que son productos distintos (Face Mask: Neck, Eye, Cover): «a FREE gift» / «2 more FREE gifts».
        const text = st.tip.regalos
          ? 'Add ' + count + ' more to get ' + (st.tip.extra === 1 ? (this.esExactoConRegalos(g) ? '1 more FREE gift' : 'a FREE gift') : st.tip.extra + ' more FREE gifts')
          : esc(c.bundleTipText).replace('{count}', count).replace('{free}', st.tip.free).replace('{extra}', st.tip.extra != null ? st.tip.extra : st.tip.free - g.freeNow);
        tip = '<button type="button" class="skc__tip-btn" data-skc-units data-group="' + gk + '" data-units="' + st.tip.units + '">' + ICONS.gift + '<span>' + text + '</span>' + ICONS.arrow + '</button>';
      }

      // 27 oct 2026: si la clienta quitó regalos que su pack aún da, puede recuperarlos gratis
      const pk = this.packsDeCarrito(this.cart).find((x) => x.main.key === m.key);
      if (pk && pk.falta) tip += '<button type="button" class="skc__tip-btn" data-skc-gift-back="' + esc(String(m.product_id)) + '">' + ICONS.gift + '<span>' + esc(c.texts.giftBack || 'Add my free gifts back') + '</span>' + ICONS.arrow + '</button>';
      return '<div class="skc__line" data-group="' + gk + '">' +
        '<div class="skc__img">' + img + '</div>' +
        '<div class="skc__info">' + titleHtml + variantHtml + badges + subbed + '</div>' +
        /* 2 oct 2026 · una linea de regalo pone FREE, no «$0» — igual que el checkout y que giftsHtml. */
        '<div class="skc__price">' + compare + '<strong>' + this.money(g.final) + '</strong></div>' +
        '<div class="skc__extra">' + sub +
          '<div class="skc__row">' + qty + '<button type="button" class="skc__remove" data-skc-remove data-keys="' + keys + '" aria-label="' + esc(c.texts.remove) + '">' + ICONS.trash + '</button></div>' +
          tip +
        '</div>' +
      '</div>';
    }

    giftsHtml(cart) {
      const c = this.cfg;
      const hasPaid = this.paid(cart).length > 0;
      const gifts = cart.items.filter((i) => this.isGift(i) && (hasPaid || !this.isPromo(i)));
      if (!gifts.length) return '';
      return gifts.map((i) => {
        const tier = this.giftTier(i) || {};
        const isFree = this.giftIsFree(cart, i, tier);
        const value = (tier.gift && tier.gift.compare) || i.original_line_price;
        const name = esc(i.product_title);
        const nameHtml = c.giftLink ? '<a class="skc__name" href="' + esc(i.url) + '">' + name + '</a>' : '<p class="skc__name">' + name + '</p>';
        const priceHtml = !isFree
          ? '<strong>' + this.money(i.final_line_price) + '</strong>'
          : (value ? '<s class="skc__compare">' + this.money(value) + '</s>' : '') + '<strong class="skc__free">' + esc(c.freeLabel) + '</strong>';
        return '<div class="skc__line skc__line--gift">' +
          '<div class="skc__img">' + (i.image ? '<img src="' + esc(this.img(i.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') + '<span class="skc__gift-ico">' + ICONS.gift + '</span></div>' +
          '<div class="skc__info">' + nameHtml + '<p class="skc__gift-note">' + (!isFree && tier.threshold ? esc(c.giftLockedText || '').replace('{amount}', this.money(this.thresholdCents(tier))) : esc(tier.label || '')) + '</p></div>' +
          '<div class="skc__price">' + priceHtml + (c.giftRemovable ? '<button type="button" class="skc__remove skc__remove--gift" data-skc-gift-remove data-key="' + esc(i.key) + '" data-tier="' + esc(tier.key || '') + '" aria-label="' + esc(c.texts.remove) + '">' + ICONS.trash + '</button>' : '') + '</div>' +
        '</div>';
      }).join('');
    }

    /* El regalo lo hace gratis la app «SkinKlean Cart Gifts» con un descuento de pedido llamado igual que
       cfg.giftDiscountTitle. Es gratis si ese descuento está en el carrito y se cumple el importe del tramo (misma regla
       que la función: lo pagado sin regalos ni protección). También vale si la línea ya viene a 0. */
    giftIsFree(cart, line, tier) {
      if (line.final_line_price === 0 && line.original_line_price > 0) return true;
      const title = this.cfg.giftDiscountTitle || 'Free gifts';
      const applied = (cart.cart_level_discount_applications || []).some((d) => d.title === title && d.total_allocated_amount > 0);
      return !!(applied && tier && tier.threshold && this.qualifying(cart) >= this.thresholdCents(tier));
    }

    renderUpsell(cart) {
      const el = this.$('[data-skc-upsell]');
      const c = this.cfg;
      if (!cart || !c.upsell || (!this.paid(cart).length && !cart.items.some((i) => this.isGift(i) && !this.isPromo(i)))) { el.hidden = true; return; }
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const list = (c.upsellProducts || []).filter((p) => !inCart.has(p.productId));
      if (!list.length) { el.hidden = true; return; }
      el.hidden = false;
      const per = window.matchMedia('(max-width:480px)').matches ? 1 : 2;
      const maxIndex = Math.max(0, list.length - per);
      this.upsellIndex = Math.min(Math.max(0, this.upsellIndex), maxIndex);
      const cards = list.map((p) => this.upsellPrice(p)).map((p) =>
        '<div class="skc__card">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" width="96" height="96" loading="lazy">' : '') +
          '<a class="skc__card-t" href="' + esc(p.url || '#') + '">' + esc(p.title) + '</a>' +
          '<p class="skc__card-p">' + (p.compare > p.price ? '<s>' + this.money(p.compare) + '</s> ' : '') + '<strong>' + this.money(p.price) + '</strong></p>' +
          '<button type="button" class="skc__card-b" data-skc-upsell-add data-variant="' + p.variantId + '">' + esc(c.upsellBtn) + '</button>' +
        '</div>').join('');
      el.innerHTML = '<div class="skc__upsell-head"><p class="skc__upsell-h">' + esc(c.upsellHeading) + '</p>' +
        (list.length > per ? '<div class="skc__upsell-nav"><button type="button" data-skc-upsell-nav data-dir="-1" aria-label="Previous">' + ICONS.arrow + '</button><button type="button" data-skc-upsell-nav data-dir="1" aria-label="Next">' + ICONS.arrow + '</button></div>' : '') +
        '</div><div class="skc__cards-vp"><div class="skc__cards">' + cards + '</div></div>'; // 19 sep: se desliza con el dedo (scroll), sin transform
      const vp = el.querySelector('.skc__cards-vp');
      if (vp) {
        vp.addEventListener('scroll', () => {
          cancelAnimationFrame(this._navRaf);
          this._navRaf = requestAnimationFrame(() => this.syncUpsellNav());
        }, { passive: true });
      }
      this.syncUpsellNav();
    }

    /* 24 sep 2026 · Las flechas del upsell se pintaban segun `upsellIndex`, que se quedo clavado
       en 0 cuando el 19 sep esto paso a deslizarse con scroll nativo y nadie lo incrementa. Efecto:
       la de la izquierda salia SIEMPRE deshabilitada, aunque hubieras deslizado a la derecha.
       Ahora el estado sale de donde esta el scroll de verdad, que es lo unico que no miente. */
    syncUpsellNav() {
      const el = this.$('[data-skc-upsell]');
      if (!el || el.hidden) return;
      const vp = el.querySelector('.skc__cards-vp');
      const nav = el.querySelector('.skc__upsell-nav');
      if (!vp || !nav) return;
      const prev = nav.querySelector('[data-dir="-1"]');
      const next = nav.querySelector('[data-dir="1"]');
      const max = vp.scrollWidth - vp.clientWidth;
      if (prev) prev.disabled = vp.scrollLeft <= 1;          // 1px de holganza: el scroll da decimales
      if (next) next.disabled = vp.scrollLeft >= max - 1;
    }

    renderFooter(cart) {
      const c = this.cfg;
      const paid = this.paid(cart);
      const spChk = this.$('[data-skc-sp]');
      if (spChk && this.cfg.sp) {
        // se pinta lo que la clienta ha elegido, no lo que aún está llegando: marcada salvo que la haya apagado
        const attr = cart.attributes && cart.attributes._sk_sp;
        spChk.checked = attr === 'off' ? false : attr === 'on' || this.cfg.sp.default || cart.items.some((i) => this.isSp(i));
      }
      /* 27 oct 2026 · El tachado es el valor de los PRODUCTOS, como la tarjeta de Kaching en la ficha: sin la protección
         de envío (antes el 3+3 salía $257 en el cajón y $252 en la ficha). El ahorro, contra lo pagado sin la protección. */
      const spPaid = cart.items.filter((i) => this.isSp(i)).reduce((s, i) => s + i.final_line_price, 0);
      const compareTotal = cart.items.reduce((s, i) => {
        if (this.isSp(i)) return s;
        if (this.isGift(i)) {
          const tier = this.giftTier(i);
          if (!this.giftIsFree(cart, i, tier)) return s + i.final_line_price;
          return s + ((tier && tier.gift && tier.gift.compare) || i.original_line_price);
        }
        return s + this.unitCompare(i) * i.quantity;
      }, 0);
      const saving = Math.max(0, compareTotal - (cart.total_price - spPaid));
      const sv = this.$('[data-skc-savings]');
      if (sv) {
        if (c.savings && saving > 0 && paid.length) {
          sv.hidden = false;
          const label = esc(String(c.savingsText || '').replace(/\s*\{amount\}\s*/g, ' ').trim());
          sv.innerHTML = '<span>' + label + '</span><strong>' + this.money(saving) + '</strong>';
        } else sv.hidden = true;
      }
      this.$('[data-skc-total]').textContent = this.money(cart.total_price);
      const tc = this.$('[data-skc-total-compare]');
      if (c.totalCompare && compareTotal > cart.total_price) { tc.hidden = false; tc.textContent = this.money(compareTotal); } else tc.hidden = true;
    }
  }

  customElements.define('cart-drawer', SKCart);
})();
